// This file is auto-generated by @hey-api/openapi-ts

import type {
  Client,
  ClientMeta,
  Options as Options2,
  RequestResult,
  TDataShape
} from './client'
import { client } from './client.gen'
import type {
  AccountChangePasswordConfirmCreateData,
  AccountChangePasswordConfirmCreateResponses,
  AccountChangePasswordRequestCreateData,
  AccountChangePasswordRequestCreateResponses,
  AccountCreateData,
  AccountCreateResponses,
  AccountDestroyData,
  AccountDestroyResponses,
  AccountLinkedAuthMethodsRetrieveData,
  AccountLinkedAuthMethodsRetrieveResponses,
  AccountNotificationPreferencesRetrieveData,
  AccountNotificationPreferencesRetrieveResponses,
  AccountNotificationPreferencesUpdateData,
  AccountNotificationPreferencesUpdateResponses,
  AccountNotificationsMarkReadCreateData,
  AccountNotificationsMarkReadCreateResponses,
  AccountNotificationsRetrieveData,
  AccountNotificationsRetrieveResponses,
  AccountNotificationsUnreadCountRetrieveData,
  AccountNotificationsUnreadCountRetrieveResponses,
  AccountOrgLinkedMethodsRetrieveData,
  AccountOrgLinkedMethodsRetrieveResponses,
  AccountOrgSocialAccountsDestroyData,
  AccountOrgSocialAccountsDestroyResponses,
  AccountPartialUpdateData,
  AccountPartialUpdateResponses,
  AccountPasskeysDestroyData,
  AccountPasskeysDestroyResponses,
  AccountPasskeysListData,
  AccountPasskeysListResponses,
  AccountPasskeysPartialUpdateData,
  AccountPasskeysPartialUpdateResponses,
  AccountPasskeysRegisterStartCreateData,
  AccountPasskeysRegisterStartCreateResponses,
  AccountPasskeysRegisterVerifyCreateData,
  AccountPasskeysRegisterVerifyCreateResponses,
  AccountRetrieveData,
  AccountRetrieveResponses,
  AccountServicesListData,
  AccountServicesListResponses,
  AccountSessionsDestroyData,
  AccountSessionsDestroyResponses,
  AccountSessionsListData,
  AccountSessionsListResponses,
  AccountSessionsRevokeAllOthersDestroyData,
  AccountSessionsRevokeAllOthersDestroyResponses,
  AccountSignInPolicyPartialUpdateData,
  AccountSignInPolicyPartialUpdateResponses,
  AccountSignInPolicyRetrieveData,
  AccountSignInPolicyRetrieveResponses,
  AccountSignInPolicyUpdateData,
  AccountSignInPolicyUpdateResponses,
  AccountSocialAccountsDestroyData,
  AccountSocialAccountsDestroyResponses,
  AccountUnlinkPasswordCreateData,
  AccountUnlinkPasswordCreateResponses,
  AccountUserPartialUpdateData,
  AccountUserPartialUpdateResponses,
  ApplicationsAccessCreateData,
  ApplicationsAccessCreateResponses,
  ApplicationsApplicationsAccessListData,
  ApplicationsApplicationsAccessListResponses,
  ApplicationsApplicationsAccessRetrieveData,
  ApplicationsApplicationsAccessRetrieveResponses,
  ApplicationsApplicationsCredentialsCreateData,
  ApplicationsApplicationsCredentialsCreateResponses,
  ApplicationsApplicationsCredentialsListData,
  ApplicationsApplicationsCredentialsListResponses,
  ApplicationsApplicationsCredentialsPartialUpdateData,
  ApplicationsApplicationsCredentialsPartialUpdateResponses,
  ApplicationsApplicationsCredentialsRetrieveData,
  ApplicationsApplicationsCredentialsRetrieveResponses,
  ApplicationsApplicationsCredentialsRevokeCreateData,
  ApplicationsApplicationsCredentialsRevokeCreateResponses,
  ApplicationsApplicationsCredentialsRotateCreateData,
  ApplicationsApplicationsCredentialsRotateCreateResponses,
  ApplicationsApplicationsListData,
  ApplicationsApplicationsListResponses,
  ApplicationsApplicationsPartialUpdateData,
  ApplicationsApplicationsPartialUpdateResponses,
  ApplicationsApplicationsRepositoriesListData,
  ApplicationsApplicationsRepositoriesListResponses,
  ApplicationsApplicationsRepositoriesRetrieveData,
  ApplicationsApplicationsRepositoriesRetrieveResponses,
  ApplicationsApplicationsRetrieveData,
  ApplicationsApplicationsRetrieveResponses,
  ApplicationsApplicationsScimPartialUpdateData,
  ApplicationsApplicationsScimPartialUpdateResponses,
  ApplicationsApplicationsScimRetrieveData,
  ApplicationsApplicationsScimRetrieveResponses,
  ApplicationsApplicationsScimRotateInboundTokenCreateData,
  ApplicationsApplicationsScimRotateInboundTokenCreateResponses,
  ApplicationsApplicationsUpdateData,
  ApplicationsApplicationsUpdateResponses,
  ApplicationsApplicationsWebhookConfigClearSecretCreateData,
  ApplicationsApplicationsWebhookConfigClearSecretCreateResponses,
  ApplicationsApplicationsWebhookConfigPartialUpdateData,
  ApplicationsApplicationsWebhookConfigPartialUpdateResponses,
  ApplicationsApplicationsWebhookConfigRetrieveData,
  ApplicationsApplicationsWebhookConfigRetrieveResponses,
  ApplicationsApplicationsWebhookConfigRotateSecretCreateData,
  ApplicationsApplicationsWebhookConfigRotateSecretCreateResponses,
  ApplicationsCreateData,
  ApplicationsCreateResponses,
  ApplicationsMobileBuildsLatestRetrieveData,
  ApplicationsMobileBuildsLatestRetrieveErrors,
  ApplicationsMobileBuildsLatestRetrieveResponses,
  ApplicationsNetworkingOrganizationsByEmailCreateData,
  ApplicationsNetworkingOrganizationsByEmailCreateErrors,
  ApplicationsNetworkingOrganizationsByEmailCreateResponses,
  ApplicationsNetworkingOrganizationsListData,
  ApplicationsNetworkingOrganizationsListResponses,
  ApplicationsRemoveDestroyData,
  ApplicationsRemoveDestroyResponses,
  ApplicationsTeamListListData,
  ApplicationsTeamListListResponses,
  ApplicationsThirdPartyCreateData,
  ApplicationsThirdPartyCreateResponses,
  ApplicationsUserCanAccessRetrieveData,
  ApplicationsUserCanAccessRetrieveErrors,
  ApplicationsUserCanAccessRetrieveResponses,
  ApplicationsUserDetailsRetrieveData,
  ApplicationsUserDetailsRetrieveResponses,
  ApplicationsUserListListData,
  ApplicationsUserListListResponses,
  ApplicationsUserMembershipRetrieveData,
  ApplicationsUserMembershipRetrieveResponses,
  ApplicationsValidateRetrieveData,
  ApplicationsValidateRetrieveResponses,
  AttachmentsCreateAvatarSignedUrlCreateData,
  AttachmentsCreateAvatarSignedUrlCreateResponses,
  AttachmentsCreateSignedUrlCreateData,
  AttachmentsCreateSignedUrlCreateResponses,
  AttachmentsDestroyData,
  AttachmentsDestroyResponses,
  AttachmentsListData,
  AttachmentsListResponses,
  AttachmentsRetrieveData,
  AttachmentsRetrieveResponses,
  AttachmentsVersionDestroyData,
  AttachmentsVersionDestroyResponses,
  AttachmentsVersionRetrieveData,
  AttachmentsVersionRetrieveResponses,
  AttachmentsVisibilityPartialUpdateData,
  AttachmentsVisibilityPartialUpdateResponses,
  AttachmentsWebhookCreateData,
  AttachmentsWebhookCreateErrors,
  AttachmentsWebhookCreateResponses,
  AuthorizationClientAuthMethodsRetrieveData,
  AuthorizationClientAuthMethodsRetrieveResponses,
  AuthorizationPasskeyAuthenticateStartCreateData,
  AuthorizationPasskeyAuthenticateStartCreateResponses,
  AuthorizationPasskeyAuthenticateVerifyCreateData,
  AuthorizationPasskeyAuthenticateVerifyCreateResponses,
  AuthorizationQrApproveCreateData,
  AuthorizationQrApproveCreateErrors,
  AuthorizationQrApproveCreateResponses,
  AuthorizationQrCancelCreateData,
  AuthorizationQrCancelCreateErrors,
  AuthorizationQrCancelCreateResponses,
  AuthorizationQrDenyCreateData,
  AuthorizationQrDenyCreateErrors,
  AuthorizationQrDenyCreateResponses,
  AuthorizationQrScanCreateData,
  AuthorizationQrScanCreateErrors,
  AuthorizationQrScanCreateResponses,
  AuthorizationQrStartCreateData,
  AuthorizationQrStartCreateErrors,
  AuthorizationQrStartCreateResponses,
  AuthorizationQrWaitCreateData,
  AuthorizationQrWaitCreateErrors,
  AuthorizationQrWaitCreateResponses,
  AuthorizationSocialAppleConnectCreateData,
  AuthorizationSocialAppleConnectCreateResponses,
  AuthorizationSocialAppleConnectUrlCreateData,
  AuthorizationSocialAppleConnectUrlCreateResponses,
  AuthorizationSocialAppleOrgConnectCreateData,
  AuthorizationSocialAppleOrgConnectCreateResponses,
  AuthorizationSocialAppleOrgConnectUrlCreateData,
  AuthorizationSocialAppleOrgConnectUrlCreateResponses,
  AuthorizationSocialAppleStartClientCreateData,
  AuthorizationSocialAppleStartClientCreateResponses,
  AuthorizationSocialAppleStartCreateData,
  AuthorizationSocialAppleStartCreateResponses,
  AuthorizationSocialAppleStateInfoRetrieveData,
  AuthorizationSocialAppleStateInfoRetrieveResponses,
  AuthorizationSocialCustomExchangeCreateData,
  AuthorizationSocialCustomExchangeCreateResponses,
  AuthorizationSocialCustomSamlExchangeCreateData,
  AuthorizationSocialCustomSamlExchangeCreateResponses,
  AuthorizationSocialCustomStartCreateData,
  AuthorizationSocialCustomStartCreateResponses,
  AuthorizationSocialEntraidConnectCreateData,
  AuthorizationSocialEntraidConnectCreateResponses,
  AuthorizationSocialEntraidConnectUrlCreateData,
  AuthorizationSocialEntraidConnectUrlCreateResponses,
  AuthorizationSocialEntraidStartCreateData,
  AuthorizationSocialEntraidStartCreateResponses,
  AuthorizationSocialEntraidStateInfoRetrieveData,
  AuthorizationSocialEntraidStateInfoRetrieveResponses,
  AuthorizationSocialExchangeClientCreateData,
  AuthorizationSocialExchangeClientCreateResponses,
  AuthorizationSocialExchangeCreateData,
  AuthorizationSocialExchangeCreateResponses,
  AuthorizationSocialGoogleClientConnectCreateData,
  AuthorizationSocialGoogleClientConnectCreateResponses,
  AuthorizationSocialGoogleClientConnectUrlCreateData,
  AuthorizationSocialGoogleClientConnectUrlCreateResponses,
  AuthorizationSocialGoogleConnectCreateData,
  AuthorizationSocialGoogleConnectCreateResponses,
  AuthorizationSocialGoogleConnectUrlCreateData,
  AuthorizationSocialGoogleConnectUrlCreateResponses,
  AuthorizationSocialGoogleStartClientCreateData,
  AuthorizationSocialGoogleStartClientCreateResponses,
  AuthorizationSocialGoogleStartCreateData,
  AuthorizationSocialGoogleStartCreateResponses,
  AuthorizationSocialGoogleStateInfoRetrieveData,
  AuthorizationSocialGoogleStateInfoRetrieveResponses,
  AuthorizationTokenClientCreateData,
  AuthorizationTokenClientCreateResponses,
  AuthorizationTokenCookieRetrieveData,
  AuthorizationTokenCookieRetrieveResponses,
  AuthorizationTokenCreateData,
  AuthorizationTokenCreateResponses,
  AuthorizationTokenLogoutRetrieveData,
  AuthorizationTokenLogoutRetrieveResponses,
  AuthorizationTokenOtpLinkVerifyCreateData,
  AuthorizationTokenOtpLinkVerifyCreateResponses,
  AuthorizationTokenOtpRequestCreateData,
  AuthorizationTokenOtpRequestCreateResponses,
  AuthorizationTokenOtpVerifyCreateData,
  AuthorizationTokenOtpVerifyCreateResponses,
  AuthorizationTokenRefreshCreateData,
  AuthorizationTokenRefreshCreateResponses,
  AuthorizationTokenServiceVerifyCreateData,
  AuthorizationTokenServiceVerifyCreateResponses,
  AuthorizationTokenVerifyCreateData,
  AuthorizationTokenVerifyCreateResponses,
  AuthorizationV2ClientsCreateData,
  AuthorizationV2ClientsCreateResponses,
  AuthorizationV2ClientsListData,
  AuthorizationV2ClientsListResponses,
  AuthorizationV2ClientsPartialUpdateData,
  AuthorizationV2ClientsPartialUpdateResponses,
  AuthorizationV2ClientsRetrieveData,
  AuthorizationV2ClientsRetrieveResponses,
  AuthorizationV2ClientsRevokeCreateData,
  AuthorizationV2ClientsRevokeCreateResponses,
  AuthorizationV2ClientsRotateCreateData,
  AuthorizationV2ClientsRotateCreateResponses,
  AuthorizationV2EmailVerifyCreateData,
  AuthorizationV2EmailVerifyCreateErrors,
  AuthorizationV2EmailVerifyCreateResponses,
  AuthorizationV2InviteAcceptCreateData,
  AuthorizationV2InviteAcceptCreateResponses,
  AuthorizationV2InviteInfoRetrieveData,
  AuthorizationV2InviteInfoRetrieveErrors,
  AuthorizationV2InviteInfoRetrieveResponses,
  AuthorizationV2InviteRequestCreateData,
  AuthorizationV2InviteRequestCreateResponses,
  AuthorizationV2PasswordRequestCreateData,
  AuthorizationV2PasswordRequestCreateResponses,
  AuthorizationV2PasswordResetCreateData,
  AuthorizationV2PasswordResetCreateResponses,
  AuthorizationV2SchemaRetrieveData,
  AuthorizationV2SchemaRetrieveResponses,
  AuthorizationV2SignupConfirmCreateData,
  AuthorizationV2SignupConfirmCreateResponses,
  AuthorizationV2SignupStartCreateData,
  AuthorizationV2SignupStartCreateResponses,
  CommonCountriesListData,
  CommonCountriesListResponses,
  CommonCountriesRetrieveData,
  CommonCountriesRetrieveResponses,
  CommonHealthRetrieveData,
  CommonHealthRetrieveResponses,
  CommonIndustriesListData,
  CommonIndustriesListResponses,
  CommonIndustriesRetrieveData,
  CommonIndustriesRetrieveResponses,
  CommonProtectedRetrieveData,
  CommonProtectedRetrieveResponses,
  IntegrationApplicationPublishCreateData,
  IntegrationApplicationPublishCreateResponses,
  IntegrationApplicationsDataRetrieveData,
  IntegrationApplicationsDataRetrieveResponses,
  IntegrationApplicationsListData,
  IntegrationApplicationsListResponses,
  IntegrationApplicationsNotificationsCreateData,
  IntegrationApplicationsNotificationsCreateResponses,
  IntegrationApplicationsRetrieveData,
  IntegrationApplicationsRetrieveResponses,
  IntegrationApplicationsRolePermissionsCreateData,
  IntegrationApplicationsRolePermissionsCreateResponses,
  IntegrationApplicationsRolesCreateData,
  IntegrationApplicationsRolesCreateResponses,
  IntegrationFeedRetrieveData,
  IntegrationFeedRetrieveResponses,
  IntegrationGoogleMailCallbackRetrieveData,
  IntegrationGoogleMailConnectionsDisconnectCreateData,
  IntegrationGoogleMailConnectionsDisconnectCreateResponses,
  IntegrationGoogleMailConnectionsRetrieveData,
  IntegrationGoogleMailConnectionsRetrieveResponses,
  IntegrationGoogleMailConnectStartCreateData,
  IntegrationGoogleMailConnectStartCreateErrors,
  IntegrationGoogleMailConnectStartCreateResponses,
  IntegrationMicrosoftGraphAvailabilityRetrieveData,
  IntegrationMicrosoftGraphAvailabilityRetrieveResponses,
  IntegrationMicrosoftGraphCallbackRetrieveData,
  IntegrationMicrosoftGraphConnectionsDisconnectCreateData,
  IntegrationMicrosoftGraphConnectionsDisconnectCreateResponses,
  IntegrationMicrosoftGraphConnectionsListData,
  IntegrationMicrosoftGraphConnectionsListResponses,
  IntegrationMicrosoftGraphConnectStartCreateData,
  IntegrationMicrosoftGraphConnectStartCreateResponses,
  IntegrationMicrosoftGraphDisconnectCreateData,
  IntegrationMicrosoftGraphDisconnectCreateResponses,
  IntegrationMicrosoftGraphStatusRetrieveData,
  IntegrationMicrosoftGraphStatusRetrieveResponses,
  IntegrationPermissionMigrationsApplyCreateData,
  IntegrationPermissionMigrationsApplyCreateResponses,
  IntegrationRpcPresetsListData,
  IntegrationRpcPresetsListResponses,
  IntegrationRpcPresetsRetrieveData,
  IntegrationRpcPresetsRetrieveResponses,
  IntegrationSetupJobsDestroyData,
  IntegrationSetupJobsDestroyResponses,
  IntegrationSetupJobsListData,
  IntegrationSetupJobsListResponses,
  IntegrationSetupJobsRetrieveData,
  IntegrationSetupJobsRetrieveResponses,
  IntegrationSetupJobsRetryCreateData,
  IntegrationSetupJobsRetryCreateResponses,
  IntegrationSyncPermissionsCreateData,
  IntegrationSyncPermissionsCreateResponses,
  IntegrationSyncRpcMethodsCreateData,
  IntegrationSyncRpcMethodsCreateResponses,
  IntegrationSyncRpcTemplatesCreateData,
  IntegrationSyncRpcTemplatesCreateResponses,
  IntegrationTeamsListData,
  IntegrationTeamsListResponses,
  IntegrationTeamsRetrieveData,
  IntegrationTeamsRetrieveResponses,
  IntegrationUserGroupsListData,
  IntegrationUserGroupsListResponses,
  IntegrationUserGroupsRetrieveData,
  IntegrationUserGroupsRetrieveResponses,
  IntegrationUserRetrieveData,
  IntegrationUserRetrieveResponses,
  IntegrationUsersCreateData,
  IntegrationUsersCreateResponses,
  IntegrationUsersInviteCreateData,
  IntegrationUsersInviteCreateResponses,
  IntegrationUsersListData,
  IntegrationUsersListResponses,
  IntegrationUsersPartialUpdateData,
  IntegrationUsersPartialUpdateResponses,
  IntegrationUsersRetrieveData,
  IntegrationUsersRetrieveResponses,
  IntegrationV2ApplicationPublishCreateData,
  IntegrationV2ApplicationPublishCreateResponses,
  IntegrationV2ApplicationsDataRetrieveData,
  IntegrationV2ApplicationsDataRetrieveResponses,
  IntegrationV2ApplicationsListData,
  IntegrationV2ApplicationsListResponses,
  IntegrationV2ApplicationsNotificationsCreateData,
  IntegrationV2ApplicationsNotificationsCreateResponses,
  IntegrationV2ApplicationsRetrieveData,
  IntegrationV2ApplicationsRetrieveResponses,
  IntegrationV2ApplicationsRolePermissionsCreateData,
  IntegrationV2ApplicationsRolePermissionsCreateResponses,
  IntegrationV2ApplicationsRolesCreateData,
  IntegrationV2ApplicationsRolesCreateResponses,
  IntegrationV2AppsRolesCreateData,
  IntegrationV2AppsRolesCreateResponses,
  IntegrationV2AppsRolesDestroyData,
  IntegrationV2AppsRolesDestroyResponses,
  IntegrationV2AppsRolesListData,
  IntegrationV2AppsRolesListResponses,
  IntegrationV2AppsRolesMembersRetrieveData,
  IntegrationV2AppsRolesMembersRetrieveResponses,
  IntegrationV2AppsRolesMembersUpdateData,
  IntegrationV2AppsRolesMembersUpdateResponses,
  IntegrationV2AppsRolesPartialUpdateData,
  IntegrationV2AppsRolesPartialUpdateResponses,
  IntegrationV2AppsRolesRetrieveData,
  IntegrationV2AppsRolesRetrieveResponses,
  IntegrationV2FeedRetrieveData,
  IntegrationV2FeedRetrieveResponses,
  IntegrationV2RpcPresetsListData,
  IntegrationV2RpcPresetsListResponses,
  IntegrationV2RpcPresetsRetrieveData,
  IntegrationV2RpcPresetsRetrieveResponses,
  IntegrationV2SetupJobsDestroyData,
  IntegrationV2SetupJobsDestroyResponses,
  IntegrationV2SetupJobsListData,
  IntegrationV2SetupJobsListResponses,
  IntegrationV2SetupJobsRetrieveData,
  IntegrationV2SetupJobsRetrieveResponses,
  IntegrationV2SetupJobsRetryCreateData,
  IntegrationV2SetupJobsRetryCreateResponses,
  IntegrationV2SyncPermissionsCreateData,
  IntegrationV2SyncPermissionsCreateResponses,
  IntegrationV2SyncRpcMethodsCreateData,
  IntegrationV2SyncRpcMethodsCreateResponses,
  IntegrationV2TeamsListData,
  IntegrationV2TeamsListResponses,
  IntegrationV2TeamsRetrieveData,
  IntegrationV2TeamsRetrieveResponses,
  IntegrationV2UserRetrieveData,
  IntegrationV2UserRetrieveResponses,
  IntegrationV2UsersCreateData,
  IntegrationV2UsersCreateResponses,
  IntegrationV2UsersInviteCreateData,
  IntegrationV2UsersInviteCreateResponses,
  IntegrationV2UsersListData,
  IntegrationV2UsersListResponses,
  IntegrationV2UsersPartialUpdateData,
  IntegrationV2UsersPartialUpdateResponses,
  IntegrationV2UsersRetrieveData,
  IntegrationV2UsersRetrieveResponses,
  InternalGoogleMailTokenCreateData,
  InternalGoogleMailTokenCreateErrors,
  InternalGoogleMailTokenCreateResponses,
  InternalMcpConnectionRetrieveData,
  InternalMcpConnectionRetrieveResponses,
  InternalMicrosoftGraphTokenCreateData,
  InternalMicrosoftGraphTokenCreateErrors,
  InternalMicrosoftGraphTokenCreateResponses,
  InternalPublicAccessCredentialsSnapshotRetrieveData,
  InternalPublicAccessCredentialsSnapshotRetrieveResponses,
  InternalPublicAccessCredentialsUsageCreateData,
  InternalPublicAccessCredentialsUsageCreateResponses,
  McpConnectionsListData,
  McpConnectionsListResponses,
  McpConnectionsRevokeData,
  McpConnectionsRevokeResponses,
  McpConnectionsScopesUpdateData,
  McpConnectionsScopesUpdateResponses,
  McpConsentApproveData,
  McpConsentApproveResponses,
  McpConsentDenyData,
  McpConsentDenyResponses,
  McpConsentRetrieveData,
  McpConsentRetrieveResponses,
  McpMyConnectionsListData,
  McpMyConnectionsListResponses,
  McpMyConnectionsRevokeData,
  McpMyConnectionsRevokeResponses,
  McpMyConnectionsScopesUpdateData,
  McpMyConnectionsScopesUpdateResponses,
  McpMyServicesListData,
  McpMyServicesListResponses,
  McpPersonalTokensCreateData,
  McpPersonalTokensCreateResponses,
  McpPoliciesListData,
  McpPoliciesListResponses,
  McpPoliciesPartialUpdateData,
  McpPoliciesPartialUpdateErrors,
  McpPoliciesPartialUpdateResponses,
  McpToolsCallCreateData,
  McpToolsCallCreateResponses,
  McpToolsRetrieveData,
  McpToolsRetrieveResponses,
  MfaConfigDownloadBackupCodesCreateData,
  MfaConfigDownloadBackupCodesCreateResponses,
  MfaConfigGenerateBackupCodesCreateData,
  MfaConfigGenerateBackupCodesCreateResponses,
  MfaConfigPartialUpdateData,
  MfaConfigPartialUpdateResponses,
  MfaConfigRetrieveData,
  MfaConfigRetrieveResponses,
  MfaConfigUpdateData,
  MfaConfigUpdateResponses,
  MfaInternalAuditLogsExportCreateData,
  MfaInternalAuditLogsExportCreateResponses,
  MfaInternalAuditLogsListData,
  MfaInternalAuditLogsListResponses,
  MfaInternalConfigsListData,
  MfaInternalConfigsListResponses,
  MfaInternalConfigsPartialUpdateData,
  MfaInternalConfigsPartialUpdateResponses,
  MfaInternalConfigsRetrieveData,
  MfaInternalConfigsRetrieveResponses,
  MfaInternalConfigsUpdateData,
  MfaInternalConfigsUpdateResponses,
  MfaInternalLockoutsDestroyData,
  MfaInternalLockoutsDestroyResponses,
  MfaInternalLockoutsListData,
  MfaInternalLockoutsListResponses,
  MfaSendOtpCreateData,
  MfaSendOtpCreateResponses,
  MfaTrustedDevicesDeleteAllDestroyData,
  MfaTrustedDevicesDeleteAllDestroyResponses,
  MfaTrustedDevicesDestroyData,
  MfaTrustedDevicesDestroyResponses,
  MfaTrustedDevicesListData,
  MfaTrustedDevicesListResponses,
  MfaVerifyBackupCodeCreateData,
  MfaVerifyBackupCodeCreateResponses,
  MfaVerifyOtpCreateData,
  MfaVerifyOtpCreateResponses,
  OnboardingInternalStepsCreateData,
  OnboardingInternalStepsCreateResponses,
  OnboardingJourneysPartialUpdateData,
  OnboardingJourneysPartialUpdateResponses,
  OnboardingJourneysRetrieveData,
  OnboardingJourneysRetrieveResponses,
  OnboardingProfileCreateData,
  OnboardingProfileCreateErrors,
  OnboardingProfileCreateResponses,
  OnboardingProfilePartialUpdateData,
  OnboardingProfilePartialUpdateResponses,
  OnboardingProfileRetrieveData,
  OnboardingProfileRetrieveResponses,
  OrganizationsAccessAddCreateData,
  OrganizationsAccessAddCreateResponses,
  OrganizationsAccessBlockCreateData,
  OrganizationsAccessBlockCreateResponses,
  OrganizationsAccessDestroyData,
  OrganizationsAccessDestroyResponses,
  OrganizationsAccessDisableMfaCreateData,
  OrganizationsAccessDisableMfaCreateResponses,
  OrganizationsAccessImpersonateCreateData,
  OrganizationsAccessImpersonateCreateResponses,
  OrganizationsAccessListData,
  OrganizationsAccessListResponses,
  OrganizationsAccessOrganigramaListData,
  OrganizationsAccessOrganigramaListResponses,
  OrganizationsAccessPartialUpdateData,
  OrganizationsAccessPartialUpdateResponses,
  OrganizationsAccessRequireMfaCreateData,
  OrganizationsAccessRequireMfaCreateResponses,
  OrganizationsAccessResendInviteCreateData,
  OrganizationsAccessResendInviteCreateResponses,
  OrganizationsAccessResetMfaCreateData,
  OrganizationsAccessResetMfaCreateResponses,
  OrganizationsAccessResetPasswordCreateData,
  OrganizationsAccessResetPasswordCreateResponses,
  OrganizationsAccessRetrieveData,
  OrganizationsAccessRetrieveResponses,
  OrganizationsAccessRevokeInviteCreateData,
  OrganizationsAccessRevokeInviteCreateResponses,
  OrganizationsAccessRolesCreateData,
  OrganizationsAccessRolesCreateResponses,
  OrganizationsAccessSessionsDestroyData,
  OrganizationsAccessSessionsDestroyResponses,
  OrganizationsAccessSessionsListData,
  OrganizationsAccessSessionsListResponses,
  OrganizationsAccessSessionsRevokeAllCreateData,
  OrganizationsAccessSessionsRevokeAllCreateResponses,
  OrganizationsAccessSignInActivityRetrieveData,
  OrganizationsAccessSignInActivityRetrieveResponses,
  OrganizationsAuditArchivesBulkDeleteDestroyData,
  OrganizationsAuditArchivesBulkDeleteDestroyResponses,
  OrganizationsAuditArchivesCreateData,
  OrganizationsAuditArchivesCreateResponses,
  OrganizationsAuditArchivesDestroyData,
  OrganizationsAuditArchivesDestroyResponses,
  OrganizationsAuditArchivesDownloadRetrieveData,
  OrganizationsAuditArchivesDownloadRetrieveErrors,
  OrganizationsAuditArchivesDownloadRetrieveResponses,
  OrganizationsAuditArchivesListData,
  OrganizationsAuditArchivesListResponses,
  OrganizationsAuditArchivesRetrieveData,
  OrganizationsAuditArchivesRetrieveResponses,
  OrganizationsAuditLogsFiltersRetrieveData,
  OrganizationsAuditLogsFiltersRetrieveResponses,
  OrganizationsAuditLogsListData,
  OrganizationsAuditLogsListResponses,
  OrganizationsAuditLogsRetrieveData,
  OrganizationsAuditLogsRetrieveResponses,
  OrganizationsAuditLogsSignInActivityRetrieveData,
  OrganizationsAuditLogsSignInActivityRetrieveResponses,
  OrganizationsDomainAvailabilityRetrieveData,
  OrganizationsDomainAvailabilityRetrieveResponses,
  OrganizationsDomainMatchRetrieveData,
  OrganizationsDomainMatchRetrieveResponses,
  OrganizationsInfoRetrieveData,
  OrganizationsInfoRetrieveResponses,
  OrganizationsJoinRequestsApproveCreateData,
  OrganizationsJoinRequestsApproveCreateResponses,
  OrganizationsJoinRequestsCreateData,
  OrganizationsJoinRequestsCreateResponses,
  OrganizationsJoinRequestsListData,
  OrganizationsJoinRequestsListResponses,
  OrganizationsJoinRequestsRejectCreateData,
  OrganizationsJoinRequestsRejectCreateResponses,
  OrganizationsOrganizationsAuthMethodsPartialUpdateData,
  OrganizationsOrganizationsAuthMethodsPartialUpdateResponses,
  OrganizationsOrganizationsAuthMethodsRetrieveData,
  OrganizationsOrganizationsAuthMethodsRetrieveResponses,
  OrganizationsOrganizationsCreateData,
  OrganizationsOrganizationsCreateResponses,
  OrganizationsOrganizationsCustomAuthProvidersCreateData,
  OrganizationsOrganizationsCustomAuthProvidersCreateResponses,
  OrganizationsOrganizationsCustomAuthProvidersDestroyData,
  OrganizationsOrganizationsCustomAuthProvidersDestroyResponses,
  OrganizationsOrganizationsCustomAuthProvidersListData,
  OrganizationsOrganizationsCustomAuthProvidersListResponses,
  OrganizationsOrganizationsCustomAuthProvidersPartialUpdateData,
  OrganizationsOrganizationsCustomAuthProvidersPartialUpdateResponses,
  OrganizationsOrganizationsCustomAuthProvidersRetrieveData,
  OrganizationsOrganizationsCustomAuthProvidersRetrieveResponses,
  OrganizationsOrganizationsDemoDisableCreateData,
  OrganizationsOrganizationsDemoDisableCreateErrors,
  OrganizationsOrganizationsDemoDisableCreateResponses,
  OrganizationsOrganizationsDemoEnableCreateData,
  OrganizationsOrganizationsDemoEnableCreateErrors,
  OrganizationsOrganizationsDemoEnableCreateResponses,
  OrganizationsOrganizationsDestroyData,
  OrganizationsOrganizationsDestroyResponses,
  OrganizationsOrganizationsEnvironmentBuildCreateData,
  OrganizationsOrganizationsEnvironmentBuildCreateErrors,
  OrganizationsOrganizationsEnvironmentBuildCreateResponses,
  OrganizationsOrganizationsEnvironmentClearCreateData,
  OrganizationsOrganizationsEnvironmentClearCreateErrors,
  OrganizationsOrganizationsEnvironmentClearCreateResponses,
  OrganizationsOrganizationsListData,
  OrganizationsOrganizationsListResponses,
  OrganizationsOrganizationsMemberAuthMethodsListData,
  OrganizationsOrganizationsMemberAuthMethodsListResponses,
  OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateData,
  OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateResponses,
  OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveData,
  OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveResponses,
  OrganizationsOrganizationsPartialUpdateData,
  OrganizationsOrganizationsPartialUpdateResponses,
  OrganizationsOrganizationsRetrieveData,
  OrganizationsOrganizationsRetrieveResponses,
  OrganizationsOrganizationsTransferOwnershipCreateData,
  OrganizationsOrganizationsTransferOwnershipCreateResponses,
  OrganizationsPermissionsUserListData,
  OrganizationsPermissionsUserListResponses,
  OrganizationsRolesCreateData,
  OrganizationsRolesCreateResponses,
  OrganizationsRolesDestroyData,
  OrganizationsRolesDestroyResponses,
  OrganizationsRolesListData,
  OrganizationsRolesListResponses,
  OrganizationsRolesPartialUpdateData,
  OrganizationsRolesPartialUpdateResponses,
  OrganizationsRolesReplaceCreateData,
  OrganizationsRolesReplaceCreateResponses,
  OrganizationsRolesRetrieveData,
  OrganizationsRolesRetrieveResponses,
  OrganizationsTeamsCreateData,
  OrganizationsTeamsCreateResponses,
  OrganizationsTeamsDestroyData,
  OrganizationsTeamsDestroyResponses,
  OrganizationsTeamsListData,
  OrganizationsTeamsListResponses,
  OrganizationsTeamsOrganigramListData,
  OrganizationsTeamsOrganigramListResponses,
  OrganizationsTeamsPartialUpdateData,
  OrganizationsTeamsPartialUpdateResponses,
  OrganizationsTeamsRetrieveData,
  OrganizationsTeamsRetrieveResponses,
  OrganizationsTeamUsersCreateData,
  OrganizationsTeamUsersCreateResponses,
  OrganizationsTeamUsersDestroyData,
  OrganizationsTeamUsersDestroyResponses,
  OrganizationsTeamUsersListData,
  OrganizationsTeamUsersListResponses,
  OrganizationsTeamUsersRetrieveData,
  OrganizationsTeamUsersRetrieveResponses,
  OrganizationsUserGroupsApplicationsRolesPartialUpdateData,
  OrganizationsUserGroupsApplicationsRolesPartialUpdateResponses,
  OrganizationsUserGroupsCreateData,
  OrganizationsUserGroupsCreateResponses,
  OrganizationsUserGroupsDestroyData,
  OrganizationsUserGroupsDestroyResponses,
  OrganizationsUserGroupsListData,
  OrganizationsUserGroupsListResponses,
  OrganizationsUserGroupsPartialUpdateData,
  OrganizationsUserGroupsPartialUpdateResponses,
  OrganizationsUserGroupsRetrieveData,
  OrganizationsUserGroupsRetrieveResponses,
  OrganizationsValidateRetrieveData,
  OrganizationsValidateRetrieveResponses,
  OrganizationsWorkspacePermissionsListData,
  OrganizationsWorkspacePermissionsListResponses,
  OrganizationsWorkspaceRolesCreateData,
  OrganizationsWorkspaceRolesCreateResponses,
  OrganizationsWorkspaceRolesDestroyData,
  OrganizationsWorkspaceRolesDestroyResponses,
  OrganizationsWorkspaceRolesListData,
  OrganizationsWorkspaceRolesListResponses,
  OrganizationsWorkspaceRolesPartialUpdateData,
  OrganizationsWorkspaceRolesPartialUpdateResponses,
  OrganizationsWorkspaceRolesRetrieveData,
  OrganizationsWorkspaceRolesRetrieveResponses,
  PermissionsCreateData,
  PermissionsCreateResponses,
  PermissionsDestroyData,
  PermissionsDestroyResponses,
  PermissionsListData,
  PermissionsListResponses,
  PermissionsPartialUpdateData,
  PermissionsPartialUpdateResponses,
  PermissionsRetrieveData,
  PermissionsRetrieveResponses,
  SchemaRetrieveData,
  SchemaRetrieveResponses,
  SettingsOutboundWebhooksWebhooksCreateData,
  SettingsOutboundWebhooksWebhooksCreateResponses,
  SettingsOutboundWebhooksWebhooksDestroyData,
  SettingsOutboundWebhooksWebhooksDestroyResponses,
  SettingsOutboundWebhooksWebhooksListData,
  SettingsOutboundWebhooksWebhooksListResponses,
  SettingsOutboundWebhooksWebhooksPartialUpdateData,
  SettingsOutboundWebhooksWebhooksPartialUpdateResponses,
  SettingsOutboundWebhooksWebhooksRetrieveData,
  SettingsOutboundWebhooksWebhooksRetrieveResponses,
  SettingsOutboundWebhooksWebhooksRevealSecretCreateData,
  SettingsOutboundWebhooksWebhooksRevealSecretCreateResponses,
  SettingsOutboundWebhooksWebhooksTestCreateData,
  SettingsOutboundWebhooksWebhooksTestCreateResponses,
  SettingsPublicAccessCredentialsCreateData,
  SettingsPublicAccessCredentialsCreateResponses,
  SettingsPublicAccessCredentialsListData,
  SettingsPublicAccessCredentialsListResponses,
  SettingsPublicAccessCredentialsPartialUpdateData,
  SettingsPublicAccessCredentialsPartialUpdateResponses,
  SettingsPublicAccessCredentialsRetrieveData,
  SettingsPublicAccessCredentialsRetrieveResponses,
  SettingsPublicAccessCredentialsRevokeCreateData,
  SettingsPublicAccessCredentialsRevokeCreateResponses,
  SettingsPublicAccessCredentialsRotateCreateData,
  SettingsPublicAccessCredentialsRotateCreateResponses,
  StaticRetrieveData,
  StaticRetrieveResponses,
  SupportReportCreateData,
  SupportReportCreateResponses,
  SupportTicketsCommentsCreateData,
  SupportTicketsCommentsCreateResponses,
  SupportTicketsCommentsListData,
  SupportTicketsCommentsListResponses,
  SupportTicketsCreateData,
  SupportTicketsCreateResponses,
  SupportTicketsListData,
  SupportTicketsListResponses,
  SupportTicketsRetrieveData,
  SupportTicketsRetrieveResponses,
  SupportTicketsUnseenCountRetrieveData,
  SupportTicketsUnseenCountRetrieveResponses,
  SupportTicketsUploadsCreateData,
  SupportTicketsUploadsCreateResponses,
  UsersAddInOrganizationCreateData,
  UsersAddInOrganizationCreateResponses,
  UsersArchiveCreateData,
  UsersArchiveCreateErrors,
  UsersArchiveCreateResponses,
  UsersArchiveDependenciesRetrieveData,
  UsersArchiveDependenciesRetrieveErrors,
  UsersArchiveDependenciesRetrieveResponses,
  UsersArchiveJobsRetrieveData,
  UsersArchiveJobsRetrieveErrors,
  UsersArchiveJobsRetrieveResponses,
  UsersArchiveReplaceAndArchiveCreateData,
  UsersArchiveReplaceAndArchiveCreateErrors,
  UsersArchiveReplaceAndArchiveCreateResponses,
  UsersEditPartialUpdateData,
  UsersEditPartialUpdateResponses,
  UsersEditUpdateData,
  UsersEditUpdateResponses,
  UsersListData,
  UsersListResponses,
  UsersLoginAdminCreateData,
  UsersLoginAdminCreateResponses,
  UsersLoginUserCreateData,
  UsersLoginUserCreateResponses,
  UsersNotificationServiceSyncCreateData,
  UsersNotificationServiceSyncCreateResponses,
  UsersPartialUpdateData,
  UsersPartialUpdateResponses,
  UsersRetrieveData,
  UsersRetrieveResponses,
  UsersSyncActiveDirectoryCreateData,
  UsersSyncActiveDirectoryCreateResponses
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta
}

/**
 * List / create service accounts for current user.
 */
export const accountRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<AccountRetrieveData, ThrowOnError>
): RequestResult<AccountRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AccountRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/',
    ...options
  })

/**
 * List / create service accounts for current user.
 */
export const accountCreate = <ThrowOnError extends boolean = false>(
  options: Options<AccountCreateData, ThrowOnError>
): RequestResult<AccountCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    AccountCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Edit or delete a service account.
 */
export const accountDestroy = <ThrowOnError extends boolean = false>(
  options: Options<AccountDestroyData, ThrowOnError>
): RequestResult<AccountDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    AccountDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/{id}/',
    ...options
  })

/**
 * Edit or delete a service account.
 */
export const accountPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<AccountPartialUpdateData, ThrowOnError>
): RequestResult<AccountPartialUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    AccountPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Confirm password change (requires ChangePassword JWT).
 */
export const accountChangePasswordConfirmCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AccountChangePasswordConfirmCreateData, ThrowOnError>
): RequestResult<
  AccountChangePasswordConfirmCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AccountChangePasswordConfirmCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'ChangePasswordJWTAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/change-password-confirm/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Request MFA-authenticated password change.
 */
export const accountChangePasswordRequestCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountChangePasswordRequestCreateData, ThrowOnError>
): RequestResult<
  AccountChangePasswordRequestCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    AccountChangePasswordRequestCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/change-password-request/',
    ...options
  })

/**
 * Return current user's linked auth methods (password + social providers).
 */
export const accountLinkedAuthMethodsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountLinkedAuthMethodsRetrieveData, ThrowOnError>
): RequestResult<
  AccountLinkedAuthMethodsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AccountLinkedAuthMethodsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/linked-auth-methods/',
    ...options
  })

/**
 * Get notification preferences
 *
 * Returns the current user's global per-app/category/channel preferences matrix.
 */
export const accountNotificationPreferencesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountNotificationPreferencesRetrieveData, ThrowOnError>
): RequestResult<
  AccountNotificationPreferencesRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AccountNotificationPreferencesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/notification-preferences/',
    ...options
  })

/**
 * Update notification preferences
 *
 * Replaces the current user's global per-app/category/channel preferences matrix.
 */
export const accountNotificationPreferencesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AccountNotificationPreferencesUpdateData, ThrowOnError>
): RequestResult<
  AccountNotificationPreferencesUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AccountNotificationPreferencesUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/notification-preferences/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * List in-app notifications
 *
 * Proxy to the Notification service: paginated list of in-app notifications.
 */
export const accountNotificationsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountNotificationsRetrieveData, ThrowOnError>
): RequestResult<
  AccountNotificationsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AccountNotificationsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/notifications/',
    ...options
  })

/**
 * Mark in-app notifications as read
 *
 * Proxy: mark in-app notifications as read; mark all if ``ids`` is empty/null.
 */
export const accountNotificationsMarkReadCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountNotificationsMarkReadCreateData, ThrowOnError>
): RequestResult<
  AccountNotificationsMarkReadCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    AccountNotificationsMarkReadCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/notifications/mark-read/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Unread in-app notifications count
 *
 * Proxy: unread in-app notifications count for the current user.
 */
export const accountNotificationsUnreadCountRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountNotificationsUnreadCountRetrieveData, ThrowOnError>
): RequestResult<
  AccountNotificationsUnreadCountRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AccountNotificationsUnreadCountRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/notifications/unread-count/',
    ...options
  })

/**
 * Return current user's org-scoped linked auth methods (e.g. org Google).
 */
export const accountOrgLinkedMethodsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<AccountOrgLinkedMethodsRetrieveData, ThrowOnError>
): RequestResult<
  AccountOrgLinkedMethodsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AccountOrgLinkedMethodsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/org-linked-methods/{org_id}/',
    ...options
  })

/**
 * Disconnect a social provider from the current user (org links + global social account).
 */
export const accountOrgSocialAccountsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<AccountOrgSocialAccountsDestroyData, ThrowOnError>
): RequestResult<
  AccountOrgSocialAccountsDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AccountOrgSocialAccountsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/org-social-accounts/{org_id}/{provider}/',
    ...options
  })

/**
 * List passkeys for the authenticated user.
 */
export const accountPasskeysList = <ThrowOnError extends boolean = false>(
  options?: Options<AccountPasskeysListData, ThrowOnError>
): RequestResult<AccountPasskeysListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AccountPasskeysListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/passkeys/',
    ...options
  })

/**
 * Delete or rename a single passkey.
 */
export const accountPasskeysDestroy = <ThrowOnError extends boolean = false>(
  options: Options<AccountPasskeysDestroyData, ThrowOnError>
): RequestResult<AccountPasskeysDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    AccountPasskeysDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/passkeys/{id}/',
    ...options
  })

/**
 * Delete or rename a single passkey.
 */
export const accountPasskeysPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AccountPasskeysPartialUpdateData, ThrowOnError>
): RequestResult<
  AccountPasskeysPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AccountPasskeysPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/passkeys/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Generate WebAuthn registration options (challenge).
 */
export const accountPasskeysRegisterStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AccountPasskeysRegisterStartCreateData, ThrowOnError>
): RequestResult<
  AccountPasskeysRegisterStartCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AccountPasskeysRegisterStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/passkeys/register/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Verify WebAuthn attestation and store the credential.
 */
export const accountPasskeysRegisterVerifyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AccountPasskeysRegisterVerifyCreateData, ThrowOnError>
): RequestResult<
  AccountPasskeysRegisterVerifyCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AccountPasskeysRegisterVerifyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/passkeys/register/verify/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * List all services.
 */
export const accountServicesList = <ThrowOnError extends boolean = false>(
  options?: Options<AccountServicesListData, ThrowOnError>
): RequestResult<AccountServicesListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AccountServicesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/services/',
    ...options
  })

/**
 * Active sign-in sessions for the requesting user.
 *
 * One row per active refresh token. DELETE blacklists the whole session chain
 * (refresh + every access token issued from it) via :func:`revoke_session`.
 */
export const accountSessionsList = <ThrowOnError extends boolean = false>(
  options?: Options<AccountSessionsListData, ThrowOnError>
): RequestResult<AccountSessionsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AccountSessionsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/sessions/',
    ...options
  })

/**
 * Active sign-in sessions for the requesting user.
 *
 * One row per active refresh token. DELETE blacklists the whole session chain
 * (refresh + every access token issued from it) via :func:`revoke_session`.
 */
export const accountSessionsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<AccountSessionsDestroyData, ThrowOnError>
): RequestResult<AccountSessionsDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    AccountSessionsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/sessions/{jti}/',
    ...options
  })

/**
 * Active sign-in sessions for the requesting user.
 *
 * One row per active refresh token. DELETE blacklists the whole session chain
 * (refresh + every access token issued from it) via :func:`revoke_session`.
 */
export const accountSessionsRevokeAllOthersDestroy = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountSessionsRevokeAllOthersDestroyData, ThrowOnError>
): RequestResult<
  AccountSessionsRevokeAllOthersDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).delete<
    AccountSessionsRevokeAllOthersDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/sessions/revoke-all-others/',
    ...options
  })

/**
 * Per-user sign-in policy — singleton for request.user.
 */
export const accountSignInPolicyRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountSignInPolicyRetrieveData, ThrowOnError>
): RequestResult<AccountSignInPolicyRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AccountSignInPolicyRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/sign-in-policy/',
    ...options
  })

/**
 * Per-user sign-in policy — singleton for request.user.
 */
export const accountSignInPolicyPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountSignInPolicyPartialUpdateData, ThrowOnError>
): RequestResult<
  AccountSignInPolicyPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).patch<
    AccountSignInPolicyPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/sign-in-policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Per-user sign-in policy — singleton for request.user.
 */
export const accountSignInPolicyUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<AccountSignInPolicyUpdateData, ThrowOnError>
): RequestResult<AccountSignInPolicyUpdateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).put<
    AccountSignInPolicyUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/sign-in-policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Disconnect a social provider from the current user. Requires at least one auth method left.
 */
export const accountSocialAccountsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<AccountSocialAccountsDestroyData, ThrowOnError>
): RequestResult<
  AccountSocialAccountsDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AccountSocialAccountsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/social-accounts/{provider}/',
    ...options
  })

/**
 * Remove password from the current user. Requires at least one social provider linked.
 */
export const accountUnlinkPasswordCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AccountUnlinkPasswordCreateData, ThrowOnError>
): RequestResult<AccountUnlinkPasswordCreateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    AccountUnlinkPasswordCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/unlink-password/',
    ...options
  })

/**
 * Edit authenticated user's password and/or email.
 */
export const accountUserPartialUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<AccountUserPartialUpdateData, ThrowOnError>
): RequestResult<AccountUserPartialUpdateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).patch<
    AccountUserPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/account/user/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApplicationsCreateData, ThrowOnError>
): RequestResult<ApplicationsCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    ApplicationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Set each member's application access to exactly the requested apps/roles.
 *
 * Reconciled as a diff (not delete-all + recreate), so unchanged access is left alone and emits no spurious webhooks. ApplicationAccess is a legacy materialization row; the canonical member-role workflow owns the business audit event. Atomic, so a mid-request failure can't leave a member with wiped access.
 *
 * Requires workspace permission: `applications.access`.
 */
export const applicationsAccessCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApplicationsAccessCreateData, ThrowOnError>
): RequestResult<ApplicationsAccessCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    ApplicationsAccessCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/access/{organization_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const applicationsApplicationsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApplicationsApplicationsListData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsListResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ApplicationsApplicationsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/',
    ...options
  })

/**
 * Returns access rows from workspaces where the caller has `applications.access`.
 */
export const applicationsApplicationsAccessList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApplicationsApplicationsAccessListData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsAccessListResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ApplicationsApplicationsAccessListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications-access/',
    ...options
  })

/**
 * Requires workspace permission: `applications.access` for the row's workspace.
 */
export const applicationsApplicationsAccessRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsApplicationsAccessRetrieveData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsAccessRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsApplicationsAccessRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications-access/{id}/',
    ...options
  })

/**
 * No workspace permission is required unless the `organization` filter is used; that filter requires `applications.view` for the selected workspace.
 */
export const applicationsApplicationsRepositoriesList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApplicationsApplicationsRepositoriesListData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsRepositoriesListResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ApplicationsApplicationsRepositoriesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications-repositories/',
    ...options
  })

/**
 * No workspace permission is required.
 */
export const applicationsApplicationsRepositoriesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsRepositoriesRetrieveData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsRepositoriesRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsApplicationsRepositoriesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications-repositories/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsApplicationsCredentialsListData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsCredentialsListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsApplicationsCredentialsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{application_id}/credentials/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsApplicationsCredentialsCreateData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsCredentialsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplicationsApplicationsCredentialsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{application_id}/credentials/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsCredentialsRetrieveData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsCredentialsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsApplicationsCredentialsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{application_id}/credentials/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsCredentialsPartialUpdateData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsCredentialsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    ApplicationsApplicationsCredentialsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{application_id}/credentials/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsRevokeCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsCredentialsRevokeCreateData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsCredentialsRevokeCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplicationsApplicationsCredentialsRevokeCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{application_id}/credentials/{id}/revoke/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsRotateCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsCredentialsRotateCreateData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsCredentialsRotateCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplicationsApplicationsCredentialsRotateCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{application_id}/credentials/{id}/rotate/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsScimRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsApplicationsScimRetrieveData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsScimRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsApplicationsScimRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/scim/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsScimPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsApplicationsScimPartialUpdateData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsScimPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    ApplicationsApplicationsScimPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/scim/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsScimRotateInboundTokenCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsScimRotateInboundTokenCreateData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsScimRotateInboundTokenCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplicationsApplicationsScimRotateInboundTokenCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/scim/rotate-inbound-token/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsWebhookConfigRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsWebhookConfigRetrieveData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsWebhookConfigRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsApplicationsWebhookConfigRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/webhook-config/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsWebhookConfigPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsWebhookConfigPartialUpdateData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsWebhookConfigPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    ApplicationsApplicationsWebhookConfigPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/webhook-config/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsWebhookConfigClearSecretCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsWebhookConfigClearSecretCreateData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsWebhookConfigClearSecretCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplicationsApplicationsWebhookConfigClearSecretCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/webhook-config/clear-secret/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsWebhookConfigRotateSecretCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsApplicationsWebhookConfigRotateSecretCreateData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsApplicationsWebhookConfigRotateSecretCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplicationsApplicationsWebhookConfigRotateSecretCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/webhook-config/rotate-secret/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const applicationsApplicationsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsApplicationsRetrieveData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsApplicationsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsApplicationsPartialUpdateData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    ApplicationsApplicationsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsApplicationsUpdateData, ThrowOnError>
): RequestResult<
  ApplicationsApplicationsUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ApplicationsApplicationsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/applications/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * The latest active build of the app: the highest `version_code` staff have published and not withdrawn. `download_url` is presigned and expires, so request it when the user is about to download rather than caching it.
 */
export const applicationsMobileBuildsLatestRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsMobileBuildsLatestRetrieveData, ThrowOnError>
): RequestResult<
  ApplicationsMobileBuildsLatestRetrieveResponses,
  ApplicationsMobileBuildsLatestRetrieveErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsMobileBuildsLatestRetrieveResponses,
    ApplicationsMobileBuildsLatestRetrieveErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/mobile-builds/latest/',
    ...options
  })

/**
 * @deprecated
 */
export const applicationsNetworkingOrganizationsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApplicationsNetworkingOrganizationsListData, ThrowOnError>
): RequestResult<
  ApplicationsNetworkingOrganizationsListResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ApplicationsNetworkingOrganizationsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/networking/organizations/',
    ...options
  })

export const applicationsNetworkingOrganizationsByEmailCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApplicationsNetworkingOrganizationsByEmailCreateData,
    ThrowOnError
  >
): RequestResult<
  ApplicationsNetworkingOrganizationsByEmailCreateResponses,
  ApplicationsNetworkingOrganizationsByEmailCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplicationsNetworkingOrganizationsByEmailCreateResponses,
    ApplicationsNetworkingOrganizationsByEmailCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/applications/networking/organizations/by-email/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsRemoveDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApplicationsRemoveDestroyData, ThrowOnError>
): RequestResult<ApplicationsRemoveDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    ApplicationsRemoveDestroyResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/remove/{app_token}/',
    ...options
  })

export const applicationsTeamListList = <ThrowOnError extends boolean = false>(
  options: Options<ApplicationsTeamListListData, ThrowOnError>
): RequestResult<ApplicationsTeamListListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    ApplicationsTeamListListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/team/{app_token}/list/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsThirdPartyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsThirdPartyCreateData, ThrowOnError>
): RequestResult<
  ApplicationsThirdPartyCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplicationsThirdPartyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/third-party/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const applicationsUserCanAccessRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsUserCanAccessRetrieveData, ThrowOnError>
): RequestResult<
  ApplicationsUserCanAccessRetrieveResponses,
  ApplicationsUserCanAccessRetrieveErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsUserCanAccessRetrieveResponses,
    ApplicationsUserCanAccessRetrieveErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/user/{app_token}/can-access/',
    ...options
  })

export const applicationsUserDetailsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsUserDetailsRetrieveData, ThrowOnError>
): RequestResult<
  ApplicationsUserDetailsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsUserDetailsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/user/{app_token}/details',
    ...options
  })

export const applicationsUserListList = <ThrowOnError extends boolean = false>(
  options: Options<ApplicationsUserListListData, ThrowOnError>
): RequestResult<ApplicationsUserListListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    ApplicationsUserListListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/user/{app_token}/list/',
    ...options
  })

/**
 * Is the caller an active member of the workspace that owns this application?
 *
 * For services that serve every member of a workspace, not only those granted the app
 * itself (Squad's org-home chat), so it must not depend on an app grant the way
 * ``details`` and ``can-access`` do. Blocked and archived memberships do not count.
 *
 * Always 200 for an authenticated caller, an unknown token included: a 404 is left to
 * mean the route does not exist, so a caller can tell an older Core from a non-member.
 */
export const applicationsUserMembershipRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsUserMembershipRetrieveData, ThrowOnError>
): RequestResult<
  ApplicationsUserMembershipRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsUserMembershipRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/user/{app_token}/membership/',
    ...options
  })

export const applicationsValidateRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApplicationsValidateRetrieveData, ThrowOnError>
): RequestResult<
  ApplicationsValidateRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ApplicationsValidateRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/applications/validate/{app_token}/',
    ...options
  })

/**
 * Workspace attachments require `attachments.view`; callers may also list their own workspace-less uploads without a workspace permission.
 */
export const attachmentsList = <ThrowOnError extends boolean = false>(
  options?: Options<AttachmentsListData, ThrowOnError>
): RequestResult<AttachmentsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AttachmentsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/attachments/',
    ...options
  })

/**
 * Workspace attachments require `attachments.delete`; callers may also delete their own workspace-less uploads without a workspace permission.
 */
export const attachmentsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsDestroyData, ThrowOnError>
): RequestResult<AttachmentsDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    AttachmentsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}/',
    ...options
  })

/**
 * Workspace attachments require `attachments.view`; callers may also retrieve their own workspace-less uploads without a workspace permission.
 */
export const attachmentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsRetrieveData, ThrowOnError>
): RequestResult<AttachmentsRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    AttachmentsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}/',
    ...options
  })

/**
 * For workspace attachments, GET requires `attachments.view` and DELETE requires `attachments.delete`. Callers may access versions of their own workspace-less uploads without a workspace permission.
 */
export const attachmentsVersionDestroy = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsVersionDestroyData, ThrowOnError>
): RequestResult<AttachmentsVersionDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    AttachmentsVersionDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}/version/{version_id}/',
    ...options
  })

/**
 * For workspace attachments, GET requires `attachments.view` and DELETE requires `attachments.delete`. Callers may access versions of their own workspace-less uploads without a workspace permission.
 */
export const attachmentsVersionRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<AttachmentsVersionRetrieveData, ThrowOnError>
): RequestResult<AttachmentsVersionRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    AttachmentsVersionRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}/version/{version_id}/',
    ...options
  })

/**
 * Set attachment visibility
 *
 * Toggle an attachment between public and private. Moves the underlying object between the public and private buckets so its URL stays valid. Workspace attachments require `attachments.upload`; callers may also update their own workspace-less uploads.
 */
export const attachmentsVisibilityPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AttachmentsVisibilityPartialUpdateData, ThrowOnError>
): RequestResult<
  AttachmentsVisibilityPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AttachmentsVisibilityPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}/visibility/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Create avatar upload URL
 *
 * Create a presigned URL for a personal avatar without workspace ownership. The PUT must send `Content-Type` equal to the returned `content_type`: it is part of the signature, so a different or missing header is rejected by the storage. No workspace permission is required.
 */
export const attachmentsCreateAvatarSignedUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AttachmentsCreateAvatarSignedUrlCreateData, ThrowOnError>
): RequestResult<
  AttachmentsCreateAvatarSignedUrlCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    AttachmentsCreateAvatarSignedUrlCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/attachments/create-avatar-signed-url/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Create workspace attachment upload URL
 *
 * Create a presigned URL for uploading an attachment owned by a workspace. The PUT must send `Content-Type` equal to the returned `content_type`: it is part of the signature, so a different or missing header is rejected by the storage. Requires workspace permission: `attachments.upload`.
 */
export const attachmentsCreateSignedUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AttachmentsCreateSignedUrlCreateData, ThrowOnError>
): RequestResult<
  AttachmentsCreateSignedUrlCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    AttachmentsCreateSignedUrlCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/attachments/create-signed-url/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Webhook for S3 events
 *
 * Handle S3 put and delete events webhook. No workspace permission is required.
 */
export const attachmentsWebhookCreate = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsWebhookCreateData, ThrowOnError>
): RequestResult<
  AttachmentsWebhookCreateResponses,
  AttachmentsWebhookCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AttachmentsWebhookCreateResponses,
    AttachmentsWebhookCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/attachments/webhook/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationClientAuthMethodsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AuthorizationClientAuthMethodsRetrieveData, ThrowOnError>
): RequestResult<
  AuthorizationClientAuthMethodsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AuthorizationClientAuthMethodsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/client/auth-methods/',
    ...options
  })

/**
 * Generate WebAuthn authentication options (challenge).
 *
 * Client-level (no organization context). The ``domain_name`` and
 * ``service_token`` fields are accepted for forward-compatibility with
 * per-organization passkey support but are currently ignored.
 */
export const authorizationPasskeyAuthenticateStartCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<
    AuthorizationPasskeyAuthenticateStartCreateData,
    ThrowOnError
  >
): RequestResult<
  AuthorizationPasskeyAuthenticateStartCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    AuthorizationPasskeyAuthenticateStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/passkey/authenticate/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Verify WebAuthn assertion and issue JWT tokens.
 *
 * Client-level authentication (no organization context). Skips MFA
 * because WebAuthn is inherently multi-factor (possession + biometric/PIN).
 *
 * The ``domain_name`` and ``service_token`` fields are accepted for
 * forward-compatibility with per-organization passkey support but are
 * currently ignored.
 */
export const authorizationPasskeyAuthenticateVerifyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    AuthorizationPasskeyAuthenticateVerifyCreateData,
    ThrowOnError
  >
): RequestResult<
  AuthorizationPasskeyAuthenticateVerifyCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationPasskeyAuthenticateVerifyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/passkey/authenticate/verify/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationQrApproveCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationQrApproveCreateData, ThrowOnError>
): RequestResult<
  AuthorizationQrApproveCreateResponses,
  AuthorizationQrApproveCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationQrApproveCreateResponses,
    AuthorizationQrApproveCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/qr/approve/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationQrCancelCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationQrCancelCreateData, ThrowOnError>
): RequestResult<
  AuthorizationQrCancelCreateResponses,
  AuthorizationQrCancelCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationQrCancelCreateResponses,
    AuthorizationQrCancelCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/qr/cancel/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationQrDenyCreate = <ThrowOnError extends boolean = false>(
  options: Options<AuthorizationQrDenyCreateData, ThrowOnError>
): RequestResult<
  AuthorizationQrDenyCreateResponses,
  AuthorizationQrDenyCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationQrDenyCreateResponses,
    AuthorizationQrDenyCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/qr/deny/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationQrScanCreate = <ThrowOnError extends boolean = false>(
  options: Options<AuthorizationQrScanCreateData, ThrowOnError>
): RequestResult<
  AuthorizationQrScanCreateResponses,
  AuthorizationQrScanCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationQrScanCreateResponses,
    AuthorizationQrScanCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/qr/scan/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationQrStartCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AuthorizationQrStartCreateData, ThrowOnError>
): RequestResult<
  AuthorizationQrStartCreateResponses,
  AuthorizationQrStartCreateErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    AuthorizationQrStartCreateResponses,
    AuthorizationQrStartCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/qr/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

export const authorizationQrWaitCreate = <ThrowOnError extends boolean = false>(
  options: Options<AuthorizationQrWaitCreateData, ThrowOnError>
): RequestResult<
  AuthorizationQrWaitCreateResponses,
  AuthorizationQrWaitCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationQrWaitCreateResponses,
    AuthorizationQrWaitCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/qr/wait/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Exchange Apple OAuth code and link Apple to the current user
 * (account-level / client connect flow). Uses platform-wide Apple credentials.
 */
export const authorizationSocialAppleConnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialAppleConnectCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialAppleConnectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialAppleConnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/apple/connect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Return Apple OAuth URL for linking Apple to the current user
 * (account-level / client connect flow). Uses platform-wide settings,
 * not per-organization Apple credentials.
 */
export const authorizationSocialAppleConnectUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialAppleConnectUrlCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialAppleConnectUrlCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialAppleConnectUrlCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/apple/connect/url/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Exchange Apple OAuth code and link org-specific Apple to the current user.
 */
export const authorizationSocialAppleOrgConnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialAppleOrgConnectCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialAppleOrgConnectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialAppleOrgConnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/apple/org-connect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Return Apple OAuth URL for linking org-specific Apple to the current user.
 */
export const authorizationSocialAppleOrgConnectUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    AuthorizationSocialAppleOrgConnectUrlCreateData,
    ThrowOnError
  >
): RequestResult<
  AuthorizationSocialAppleOrgConnectUrlCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialAppleOrgConnectUrlCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/apple/org-connect/url/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Return Apple Sign In OAuth URL for org-scoped login.
 */
export const authorizationSocialAppleStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialAppleStartCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialAppleStartCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialAppleStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/apple/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Return Apple Sign In OAuth URL for account-level (client) login.
 */
export const authorizationSocialAppleStartClientCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialAppleStartClientCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialAppleStartClientCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialAppleStartClientCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/apple/start/client/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Public endpoint to read return_origin from signed Apple social state.
 */
export const authorizationSocialAppleStateInfoRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AuthorizationSocialAppleStateInfoRetrieveData, ThrowOnError>
): RequestResult<
  AuthorizationSocialAppleStateInfoRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AuthorizationSocialAppleStateInfoRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/apple/state-info/',
    ...options
  })

/**
 * Build an IdP-side authorize URL and return it to the SPA.
 */
export const authorizationSocialCustomStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialCustomStartCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialCustomStartCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialCustomStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/custom/{provider_id}/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Exchange ``code`` for an authenticated JWT pair (OIDC / OAuth2 only).
 */
export const authorizationSocialCustomExchangeCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialCustomExchangeCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialCustomExchangeCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialCustomExchangeCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/custom/exchange/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Trade a SAML handoff token for the JWT pair.
 */
export const authorizationSocialCustomSamlExchangeCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    AuthorizationSocialCustomSamlExchangeCreateData,
    ThrowOnError
  >
): RequestResult<
  AuthorizationSocialCustomSamlExchangeCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialCustomSamlExchangeCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/custom/saml/exchange/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Exchange Microsoft Entra ID OAuth code and link Microsoft to the current user (connect flow).
 */
export const authorizationSocialEntraidConnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialEntraidConnectCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialEntraidConnectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialEntraidConnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/entraid/connect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Return Microsoft Entra ID OAuth URL for linking Microsoft to the current user (connect flow).
 */
export const authorizationSocialEntraidConnectUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialEntraidConnectUrlCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialEntraidConnectUrlCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialEntraidConnectUrlCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/entraid/connect/url/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Return Microsoft Entra ID OAuth URL for org-scoped login.
 */
export const authorizationSocialEntraidStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialEntraidStartCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialEntraidStartCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialEntraidStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/entraid/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Public endpoint to read return_origin from signed Entra ID social state (for relay).
 */
export const authorizationSocialEntraidStateInfoRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<
    AuthorizationSocialEntraidStateInfoRetrieveData,
    ThrowOnError
  >
): RequestResult<
  AuthorizationSocialEntraidStateInfoRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AuthorizationSocialEntraidStateInfoRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/entraid/state-info/',
    ...options
  })

export const authorizationSocialExchangeCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialExchangeCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialExchangeCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialExchangeCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/exchange/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationSocialExchangeClientCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialExchangeClientCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialExchangeClientCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialExchangeClientCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/exchange/client/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Exchange Google OAuth code and link Google to the current user (connect flow).
 */
export const authorizationSocialGoogleClientConnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    AuthorizationSocialGoogleClientConnectCreateData,
    ThrowOnError
  >
): RequestResult<
  AuthorizationSocialGoogleClientConnectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialGoogleClientConnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/google/client-connect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Return Google OAuth URL for linking Google to the current user (connect flow).
 */
export const authorizationSocialGoogleClientConnectUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    AuthorizationSocialGoogleClientConnectUrlCreateData,
    ThrowOnError
  >
): RequestResult<
  AuthorizationSocialGoogleClientConnectUrlCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialGoogleClientConnectUrlCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/google/client-connect/url/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Exchange Google OAuth code and link org-specific Google to the current user.
 */
export const authorizationSocialGoogleConnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialGoogleConnectCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialGoogleConnectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialGoogleConnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/google/connect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Return Google OAuth URL for linking org-specific Google to the current user.
 */
export const authorizationSocialGoogleConnectUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialGoogleConnectUrlCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialGoogleConnectUrlCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialGoogleConnectUrlCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/google/connect/url/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Start Google sign-in for a workspace, on the workspace's own client or the platform's.
 */
export const authorizationSocialGoogleStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialGoogleStartCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialGoogleStartCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialGoogleStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/google/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationSocialGoogleStartClientCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationSocialGoogleStartClientCreateData, ThrowOnError>
): RequestResult<
  AuthorizationSocialGoogleStartClientCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationSocialGoogleStartClientCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/social/google/start/client/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Public endpoint to read return_origin and redirect_uri from signed Google social state.
 */
export const authorizationSocialGoogleStateInfoRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<
    AuthorizationSocialGoogleStateInfoRetrieveData,
    ThrowOnError
  >
): RequestResult<
  AuthorizationSocialGoogleStateInfoRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AuthorizationSocialGoogleStateInfoRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/social/google/state-info/',
    ...options
  })

/**
 * Obtain JWT access and refresh tokens under organization password policy.
 */
export const authorizationTokenCreate = <ThrowOnError extends boolean = false>(
  options: Options<AuthorizationTokenCreateData, ThrowOnError>
): RequestResult<AuthorizationTokenCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    AuthorizationTokenCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/token/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Obtain JWT token pair for client flow (without domain context).
 */
export const authorizationTokenClientCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationTokenClientCreateData, ThrowOnError>
): RequestResult<
  AuthorizationTokenClientCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationTokenClientCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/token/client/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get access token using refresh token from cookie.
 *
 * Reads the refresh token from (in priority order):
 * 1. The ``cookie_token`` cookie
 * 2. The ``refresh`` query parameter (fallback for cross-origin local dev)
 */
export const authorizationTokenCookieRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AuthorizationTokenCookieRetrieveData, ThrowOnError>
): RequestResult<
  AuthorizationTokenCookieRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AuthorizationTokenCookieRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/token/cookie/',
    ...options
  })

/**
 * Logout user, blacklist the whole session, and clear the refresh cookie.
 */
export const authorizationTokenLogoutRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AuthorizationTokenLogoutRetrieveData, ThrowOnError>
): RequestResult<
  AuthorizationTokenLogoutRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AuthorizationTokenLogoutRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/token/logout/',
    ...options
  })

/**
 * Verify a magic-link token from the email-OTP login email.
 *
 * Unlike ``EmailOTPVerifyView``, the link itself is the credential — no
 * bearer ``otp_access_token`` is required since the link travels in the
 * email, which proves email ownership. Marks the underlying ``OTPCode`` as
 * USED so the 6-digit code path is invalidated in lockstep.
 */
export const authorizationTokenOtpLinkVerifyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationTokenOtpLinkVerifyCreateData, ThrowOnError>
): RequestResult<
  AuthorizationTokenOtpLinkVerifyCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationTokenOtpLinkVerifyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/token/otp/link/verify/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Start passwordless email-OTP sign-in.
 *
 * Always returns a uniform success shape to prevent user enumeration. An OTP
 * is dispatched and an access token is returned only when:
 * * ``settings.EMAIL_OTP_LOGIN_ENABLED`` is True
 * * If ``domain_name`` is provided, the resolved organization has the
 * ``email_otp`` method enabled.
 * * The submitted email matches an existing active user.
 */
export const authorizationTokenOtpRequestCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationTokenOtpRequestCreateData, ThrowOnError>
): RequestResult<
  AuthorizationTokenOtpRequestCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationTokenOtpRequestCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/token/otp/request/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Verify an email-OTP code and issue full access+refresh tokens.
 *
 * Unlike ``UserTokenObtainPairView``, this flow **skips** the MFA gate because
 * ownership of the email was already proven by the OTP itself.
 */
export const authorizationTokenOtpVerifyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationTokenOtpVerifyCreateData, ThrowOnError>
): RequestResult<
  AuthorizationTokenOtpVerifyCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationTokenOtpVerifyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'EmailOTPJWTAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/token/otp/verify/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Takes a refresh type JSON web token and returns an access type JSON web
 * token if the refresh token is valid.
 */
export const authorizationTokenRefreshCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationTokenRefreshCreateData, ThrowOnError>
): RequestResult<
  AuthorizationTokenRefreshCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationTokenRefreshCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/token/refresh/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationTokenServiceVerifyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationTokenServiceVerifyCreateData, ThrowOnError>
): RequestResult<
  AuthorizationTokenServiceVerifyCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationTokenServiceVerifyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/token/service/verify/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationTokenVerifyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationTokenVerifyCreateData, ThrowOnError>
): RequestResult<
  AuthorizationTokenVerifyCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationTokenVerifyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/token/verify/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.view`.
 */
export const authorizationV2ClientsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AuthorizationV2ClientsListData, ThrowOnError>
): RequestResult<AuthorizationV2ClientsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AuthorizationV2ClientsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/clients/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const authorizationV2ClientsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2ClientsCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2ClientsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2ClientsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/clients/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.view`.
 */
export const authorizationV2ClientsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2ClientsRetrieveData, ThrowOnError>
): RequestResult<
  AuthorizationV2ClientsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AuthorizationV2ClientsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/clients/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const authorizationV2ClientsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2ClientsPartialUpdateData, ThrowOnError>
): RequestResult<
  AuthorizationV2ClientsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AuthorizationV2ClientsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/clients/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const authorizationV2ClientsRevokeCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2ClientsRevokeCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2ClientsRevokeCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2ClientsRevokeCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/clients/{id}/revoke/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const authorizationV2ClientsRotateCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2ClientsRotateCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2ClientsRotateCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2ClientsRotateCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/clients/{id}/rotate/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Allauth-backed email verification endpoint.
 */
export const authorizationV2EmailVerifyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2EmailVerifyCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2EmailVerifyCreateResponses,
  AuthorizationV2EmailVerifyCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2EmailVerifyCreateResponses,
    AuthorizationV2EmailVerifyCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/v2/email/verify/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const authorizationV2InviteAcceptCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2InviteAcceptCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2InviteAcceptCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2InviteAcceptCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/invite/accept/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Resolve invite metadata so the UI can branch on whether the user already has a password.
 */
export const authorizationV2InviteInfoRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2InviteInfoRetrieveData, ThrowOnError>
): RequestResult<
  AuthorizationV2InviteInfoRetrieveResponses,
  AuthorizationV2InviteInfoRetrieveErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AuthorizationV2InviteInfoRetrieveResponses,
    AuthorizationV2InviteInfoRetrieveErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/v2/invite/info/',
    ...options
  })

export const authorizationV2InviteRequestCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2InviteRequestCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2InviteRequestCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2InviteRequestCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/invite/request/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * 404 when the request expired or was opened by another user.
 */
export const mcpConsentRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<McpConsentRetrieveData, ThrowOnError>
): RequestResult<McpConsentRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    McpConsentRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/mcp/consent/{request_id}/',
    ...options
  })

export const mcpConsentApprove = <ThrowOnError extends boolean = false>(
  options: Options<McpConsentApproveData, ThrowOnError>
): RequestResult<McpConsentApproveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    McpConsentApproveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/mcp/consent/{request_id}/approve/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const mcpConsentDeny = <ThrowOnError extends boolean = false>(
  options: Options<McpConsentDenyData, ThrowOnError>
): RequestResult<McpConsentDenyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    McpConsentDenyResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/mcp/consent/{request_id}/deny/',
    ...options
  })

/**
 * Allauth-backed password reset request endpoint.
 */
export const authorizationV2PasswordRequestCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2PasswordRequestCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2PasswordRequestCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2PasswordRequestCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/v2/password/request/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Allauth-backed password reset confirmation endpoint.
 */
export const authorizationV2PasswordResetCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2PasswordResetCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2PasswordResetCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2PasswordResetCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/v2/password/reset/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const authorizationV2SchemaRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<AuthorizationV2SchemaRetrieveData, ThrowOnError>
): RequestResult<
  AuthorizationV2SchemaRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AuthorizationV2SchemaRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/schema',
    ...options
  })

/**
 * Two-step simple registration. Confirm.
 */
export const authorizationV2SignupConfirmCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2SignupConfirmCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2SignupConfirmCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2SignupConfirmCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/signup/confirm/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Two-step simple registration. Start.
 */
export const authorizationV2SignupStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AuthorizationV2SignupStartCreateData, ThrowOnError>
): RequestResult<
  AuthorizationV2SignupStartCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthorizationV2SignupStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/authorization/v2/signup/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const commonCountriesList = <ThrowOnError extends boolean = false>(
  options?: Options<CommonCountriesListData, ThrowOnError>
): RequestResult<CommonCountriesListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    CommonCountriesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/common/countries/',
    ...options
  })

export const commonCountriesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CommonCountriesRetrieveData, ThrowOnError>
): RequestResult<CommonCountriesRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    CommonCountriesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/common/countries/{id}/',
    ...options
  })

export const commonHealthRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<CommonHealthRetrieveData, ThrowOnError>
): RequestResult<CommonHealthRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    CommonHealthRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/common/health/',
    ...options
  })

export const commonIndustriesList = <ThrowOnError extends boolean = false>(
  options?: Options<CommonIndustriesListData, ThrowOnError>
): RequestResult<CommonIndustriesListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    CommonIndustriesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/common/industries/',
    ...options
  })

export const commonIndustriesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CommonIndustriesRetrieveData, ThrowOnError>
): RequestResult<CommonIndustriesRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    CommonIndustriesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/common/industries/{id}/',
    ...options
  })

export const commonProtectedRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<CommonProtectedRetrieveData, ThrowOnError>
): RequestResult<CommonProtectedRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    CommonProtectedRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/common/protected/',
    ...options
  })

export const integrationApplicationPublishCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationApplicationPublishCreateData, ThrowOnError>
): RequestResult<
  IntegrationApplicationPublishCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationApplicationPublishCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/application/publish/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const integrationApplicationsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationApplicationsListData, ThrowOnError>
): RequestResult<IntegrationApplicationsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationApplicationsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/applications/',
    ...options
  })

export const integrationApplicationsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationApplicationsRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationApplicationsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationApplicationsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/applications/{id}/',
    ...options
  })

/**
 * Get application data by Saas-App-Token
 */
export const integrationApplicationsDataRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationApplicationsDataRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationApplicationsDataRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    IntegrationApplicationsDataRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/applications/data/',
    ...options
  })

/**
 * Set Notification categories from apps
 */
export const integrationApplicationsNotificationsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationApplicationsNotificationsCreateData, ThrowOnError>
): RequestResult<
  IntegrationApplicationsNotificationsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationApplicationsNotificationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/applications/notifications/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Set Team role permissions from apps
 *
 * @deprecated
 */
export const integrationApplicationsRolePermissionsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    IntegrationApplicationsRolePermissionsCreateData,
    ThrowOnError
  >
): RequestResult<
  IntegrationApplicationsRolePermissionsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationApplicationsRolePermissionsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/applications/role-permissions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const integrationApplicationsRolesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationApplicationsRolesCreateData, ThrowOnError>
): RequestResult<
  IntegrationApplicationsRolesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationApplicationsRolesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/applications/roles/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Legacy compatibility endpoint. It keeps the old integration audit-feed response shape, but the data is now read from the shared Mongo-backed audit log. Consumers should migrate to the primary organization audit logs endpoint at `/organizations/{organization_id}/audit-logs/` and this endpoint should be removed after confirming that no integration clients still depend on it.
 *
 * @deprecated
 */
export const integrationFeedRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationFeedRetrieveData, ThrowOnError>
): RequestResult<IntegrationFeedRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationFeedRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/feed/',
    ...options
  })

export const integrationGoogleMailCallbackRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationGoogleMailCallbackRetrieveData, ThrowOnError>
): RequestResult<unknown, unknown, ThrowOnError> =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: '/integration/google/mail/callback/',
    ...options
  })

export const integrationGoogleMailConnectStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationGoogleMailConnectStartCreateData, ThrowOnError>
): RequestResult<
  IntegrationGoogleMailConnectStartCreateResponses,
  IntegrationGoogleMailConnectStartCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationGoogleMailConnectStartCreateResponses,
    IntegrationGoogleMailConnectStartCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/google/mail/connect/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * The caller's connected Gmail mailboxes in one workspace, and whether Gmail is available at all.
 */
export const integrationGoogleMailConnectionsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationGoogleMailConnectionsRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationGoogleMailConnectionsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationGoogleMailConnectionsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/google/mail/connections/',
    ...options
  })

/**
 * Disconnect one Gmail mailbox, leaving the user's other mailboxes alone.
 */
export const integrationGoogleMailConnectionsDisconnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    IntegrationGoogleMailConnectionsDisconnectCreateData,
    ThrowOnError
  >
): RequestResult<
  IntegrationGoogleMailConnectionsDisconnectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationGoogleMailConnectionsDisconnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/google/mail/connections/{connection_id}/disconnect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Which Entra apps can connect an Outlook mailbox here, so the UI offers only what works.
 */
export const integrationMicrosoftGraphAvailabilityRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    IntegrationMicrosoftGraphAvailabilityRetrieveData,
    ThrowOnError
  >
): RequestResult<
  IntegrationMicrosoftGraphAvailabilityRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationMicrosoftGraphAvailabilityRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/microsoft/graph/availability/',
    ...options
  })

export const integrationMicrosoftGraphCallbackRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationMicrosoftGraphCallbackRetrieveData, ThrowOnError>
): RequestResult<unknown, unknown, ThrowOnError> =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: '/integration/microsoft/graph/callback/',
    ...options
  })

export const integrationMicrosoftGraphConnectStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    IntegrationMicrosoftGraphConnectStartCreateData,
    ThrowOnError
  >
): RequestResult<
  IntegrationMicrosoftGraphConnectStartCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationMicrosoftGraphConnectStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/microsoft/graph/connect/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * The caller's connected mailboxes, for the settings screen.
 */
export const integrationMicrosoftGraphConnectionsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationMicrosoftGraphConnectionsListData, ThrowOnError>
): RequestResult<
  IntegrationMicrosoftGraphConnectionsListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationMicrosoftGraphConnectionsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/microsoft/graph/connections/',
    ...options
  })

/**
 * Disconnect one mailbox, leaving the user's other mailboxes alone.
 */
export const integrationMicrosoftGraphConnectionsDisconnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    IntegrationMicrosoftGraphConnectionsDisconnectCreateData,
    ThrowOnError
  >
): RequestResult<
  IntegrationMicrosoftGraphConnectionsDisconnectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationMicrosoftGraphConnectionsDisconnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/microsoft/graph/connections/{connection_id}/disconnect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Disconnects every mailbox of the caller at once. Use POST /integration/microsoft/graph/connections/{connection_id}/disconnect/.
 *
 * @deprecated
 */
export const integrationMicrosoftGraphDisconnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationMicrosoftGraphDisconnectCreateData, ThrowOnError>
): RequestResult<
  IntegrationMicrosoftGraphDisconnectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationMicrosoftGraphDisconnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/microsoft/graph/disconnect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Reports a single connection, so it cannot describe a user with several mailboxes. Use GET /integration/microsoft/graph/connections/.
 *
 * @deprecated
 */
export const integrationMicrosoftGraphStatusRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationMicrosoftGraphStatusRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationMicrosoftGraphStatusRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationMicrosoftGraphStatusRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/microsoft/graph/status/',
    ...options
  })

/**
 * Apply a single permission migration (rename/merge) for the scoped repository.
 *
 * Auth: same ``Saas-Secret-Token`` flow as :class:`ApplicationPermissionSyncView` —
 * the ``ApplicationRepository`` is resolved from the token, not the payload, so the
 * caller never picks the scope. Idempotency is enforced via
 * ``unique(application_repository, name)`` on ``IntegrationPermissionMigration``:
 * a previously-applied migration returns ``applied=true, skipped=true`` without
 * touching permissions.
 */
export const integrationPermissionMigrationsApplyCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationPermissionMigrationsApplyCreateData, ThrowOnError>
): RequestResult<
  IntegrationPermissionMigrationsApplyCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationPermissionMigrationsApplyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/permission-migrations/apply/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const integrationRpcPresetsList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationRpcPresetsListData, ThrowOnError>
): RequestResult<IntegrationRpcPresetsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationRpcPresetsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/rpc/presets/',
    ...options
  })

export const integrationRpcPresetsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationRpcPresetsRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationRpcPresetsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationRpcPresetsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/rpc/presets/{id}/',
    ...options
  })

export const integrationSetupJobsList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationSetupJobsListData, ThrowOnError>
): RequestResult<IntegrationSetupJobsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationSetupJobsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/setup/jobs/',
    ...options
  })

export const integrationSetupJobsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationSetupJobsDestroyData, ThrowOnError>
): RequestResult<IntegrationSetupJobsDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    IntegrationSetupJobsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/setup/jobs/{id}/',
    ...options
  })

export const integrationSetupJobsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationSetupJobsRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationSetupJobsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationSetupJobsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/setup/jobs/{id}/',
    ...options
  })

export const integrationSetupJobsRetryCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationSetupJobsRetryCreateData, ThrowOnError>
): RequestResult<
  IntegrationSetupJobsRetryCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationSetupJobsRetryCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/setup/jobs/{id}/retry/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Sync permissions from the applications.
 */
export const integrationSyncPermissionsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationSyncPermissionsCreateData, ThrowOnError>
): RequestResult<
  IntegrationSyncPermissionsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationSyncPermissionsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/sync-permissions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Sync rpc methods from the applications.
 */
export const integrationSyncRpcMethodsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationSyncRpcMethodsCreateData, ThrowOnError>
): RequestResult<
  IntegrationSyncRpcMethodsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationSyncRpcMethodsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/sync-rpc-methods/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Sync RPC method templates and pipeline steps from the applications.
 */
export const integrationSyncRpcTemplatesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationSyncRpcTemplatesCreateData, ThrowOnError>
): RequestResult<
  IntegrationSyncRpcTemplatesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationSyncRpcTemplatesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/sync-rpc-templates/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Team
 */
export const integrationTeamsList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationTeamsListData, ThrowOnError>
): RequestResult<IntegrationTeamsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationTeamsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/teams/',
    ...options
  })

/**
 * Team
 */
export const integrationTeamsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationTeamsRetrieveData, ThrowOnError>
): RequestResult<IntegrationTeamsRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    IntegrationTeamsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/teams/{id}/',
    ...options
  })

/**
 * UserGroup
 */
export const integrationUserGroupsList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationUserGroupsListData, ThrowOnError>
): RequestResult<IntegrationUserGroupsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationUserGroupsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/user-groups/',
    ...options
  })

/**
 * UserGroup
 */
export const integrationUserGroupsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationUserGroupsRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationUserGroupsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationUserGroupsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/user-groups/{id}/',
    ...options
  })

/**
 * For Saas-secret-token
 */
export const integrationUserRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationUserRetrieveData, ThrowOnError>
): RequestResult<IntegrationUserRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    IntegrationUserRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/user/{sso_id}/',
    ...options
  })

/**
 * User
 */
export const integrationUsersList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationUsersListData, ThrowOnError>
): RequestResult<IntegrationUsersListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationUsersListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      { name: 'Saas-secret-token', type: 'apiKey' },
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/users/',
    ...options
  })

/**
 * User
 */
export const integrationUsersCreate = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationUsersCreateData, ThrowOnError>
): RequestResult<IntegrationUsersCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    IntegrationUsersCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      { name: 'Saas-secret-token', type: 'apiKey' },
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/users/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * User
 */
export const integrationUsersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationUsersRetrieveData, ThrowOnError>
): RequestResult<IntegrationUsersRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    IntegrationUsersRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      { name: 'Saas-secret-token', type: 'apiKey' },
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/users/{sso_id}/',
    ...options
  })

/**
 * User
 */
export const integrationUsersPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationUsersPartialUpdateData, ThrowOnError>
): RequestResult<
  IntegrationUsersPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    IntegrationUsersPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/users/{sso_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Invite users into the organization of the application making the call.
 */
export const integrationUsersInviteCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationUsersInviteCreateData, ThrowOnError>
): RequestResult<
  IntegrationUsersInviteCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationUsersInviteCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/users/invite/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const integrationV2ApplicationPublishCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2ApplicationPublishCreateData, ThrowOnError>
): RequestResult<
  IntegrationV2ApplicationPublishCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2ApplicationPublishCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/application/publish/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const integrationV2ApplicationsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationV2ApplicationsListData, ThrowOnError>
): RequestResult<
  IntegrationV2ApplicationsListResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    IntegrationV2ApplicationsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/applications/',
    ...options
  })

export const integrationV2ApplicationsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2ApplicationsRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationV2ApplicationsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationV2ApplicationsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/applications/{id}/',
    ...options
  })

/**
 * Get application data by Saas-App-Token
 */
export const integrationV2ApplicationsDataRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationV2ApplicationsDataRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationV2ApplicationsDataRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    IntegrationV2ApplicationsDataRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/applications/data/',
    ...options
  })

/**
 * Set Notification categories from apps
 */
export const integrationV2ApplicationsNotificationsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    IntegrationV2ApplicationsNotificationsCreateData,
    ThrowOnError
  >
): RequestResult<
  IntegrationV2ApplicationsNotificationsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2ApplicationsNotificationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/applications/notifications/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Set Team role permissions from apps
 *
 * @deprecated
 */
export const integrationV2ApplicationsRolePermissionsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    IntegrationV2ApplicationsRolePermissionsCreateData,
    ThrowOnError
  >
): RequestResult<
  IntegrationV2ApplicationsRolePermissionsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2ApplicationsRolePermissionsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/applications/role-permissions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const integrationV2ApplicationsRolesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2ApplicationsRolesCreateData, ThrowOnError>
): RequestResult<
  IntegrationV2ApplicationsRolesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2ApplicationsRolesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/applications/roles/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.view`.
 */
export const integrationV2AppsRolesList = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2AppsRolesListData, ThrowOnError>
): RequestResult<IntegrationV2AppsRolesListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    IntegrationV2AppsRolesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/apps/{application_id}/roles/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const integrationV2AppsRolesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2AppsRolesCreateData, ThrowOnError>
): RequestResult<
  IntegrationV2AppsRolesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2AppsRolesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/apps/{application_id}/roles/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const integrationV2AppsRolesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2AppsRolesDestroyData, ThrowOnError>
): RequestResult<
  IntegrationV2AppsRolesDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    IntegrationV2AppsRolesDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/apps/{application_id}/roles/{role_id}/',
    ...options
  })

/**
 * Requires workspace permission: `applications.view`.
 */
export const integrationV2AppsRolesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2AppsRolesRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationV2AppsRolesRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationV2AppsRolesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/apps/{application_id}/roles/{role_id}/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const integrationV2AppsRolesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2AppsRolesPartialUpdateData, ThrowOnError>
): RequestResult<
  IntegrationV2AppsRolesPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    IntegrationV2AppsRolesPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/apps/{application_id}/roles/{role_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.access`.
 */
export const integrationV2AppsRolesMembersRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2AppsRolesMembersRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationV2AppsRolesMembersRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationV2AppsRolesMembersRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/apps/{application_id}/roles/{role_id}/members/',
    ...options
  })

/**
 * Requires workspace permission: `applications.access`.
 */
export const integrationV2AppsRolesMembersUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2AppsRolesMembersUpdateData, ThrowOnError>
): RequestResult<
  IntegrationV2AppsRolesMembersUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).put<
    IntegrationV2AppsRolesMembersUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/apps/{application_id}/roles/{role_id}/members/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Legacy compatibility endpoint. It keeps the old integration audit-feed response shape, but the data is now read from the shared Mongo-backed audit log. Consumers should migrate to the primary organization audit logs endpoint at `/organizations/{organization_id}/audit-logs/` and this endpoint should be removed after confirming that no integration clients still depend on it.
 *
 * @deprecated
 */
export const integrationV2FeedRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationV2FeedRetrieveData, ThrowOnError>
): RequestResult<IntegrationV2FeedRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationV2FeedRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/feed/',
    ...options
  })

export const integrationV2RpcPresetsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationV2RpcPresetsListData, ThrowOnError>
): RequestResult<IntegrationV2RpcPresetsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationV2RpcPresetsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/rpc/presets/',
    ...options
  })

export const integrationV2RpcPresetsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2RpcPresetsRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationV2RpcPresetsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationV2RpcPresetsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/rpc/presets/{id}/',
    ...options
  })

export const integrationV2SetupJobsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationV2SetupJobsListData, ThrowOnError>
): RequestResult<IntegrationV2SetupJobsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationV2SetupJobsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/setup/jobs/',
    ...options
  })

export const integrationV2SetupJobsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2SetupJobsDestroyData, ThrowOnError>
): RequestResult<
  IntegrationV2SetupJobsDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    IntegrationV2SetupJobsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/setup/jobs/{id}/',
    ...options
  })

export const integrationV2SetupJobsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2SetupJobsRetrieveData, ThrowOnError>
): RequestResult<
  IntegrationV2SetupJobsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IntegrationV2SetupJobsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/setup/jobs/{id}/',
    ...options
  })

export const integrationV2SetupJobsRetryCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2SetupJobsRetryCreateData, ThrowOnError>
): RequestResult<
  IntegrationV2SetupJobsRetryCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2SetupJobsRetryCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/setup/jobs/{id}/retry/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Sync permissions from the applications.
 */
export const integrationV2SyncPermissionsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2SyncPermissionsCreateData, ThrowOnError>
): RequestResult<
  IntegrationV2SyncPermissionsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2SyncPermissionsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/sync-permissions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Sync rpc methods from the applications.
 */
export const integrationV2SyncRpcMethodsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2SyncRpcMethodsCreateData, ThrowOnError>
): RequestResult<
  IntegrationV2SyncRpcMethodsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2SyncRpcMethodsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/sync-rpc-methods/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Team
 */
export const integrationV2TeamsList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationV2TeamsListData, ThrowOnError>
): RequestResult<IntegrationV2TeamsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationV2TeamsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/teams/',
    ...options
  })

/**
 * Team
 */
export const integrationV2TeamsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2TeamsRetrieveData, ThrowOnError>
): RequestResult<IntegrationV2TeamsRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    IntegrationV2TeamsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/teams/{id}/',
    ...options
  })

/**
 * For Saas-secret-token
 */
export const integrationV2UserRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationV2UserRetrieveData, ThrowOnError>
): RequestResult<IntegrationV2UserRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    IntegrationV2UserRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/user/{sso_id}/',
    ...options
  })

/**
 * User
 */
export const integrationV2UsersList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationV2UsersListData, ThrowOnError>
): RequestResult<IntegrationV2UsersListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    IntegrationV2UsersListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      { name: 'Saas-secret-token', type: 'apiKey' },
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/users/',
    ...options
  })

/**
 * User
 */
export const integrationV2UsersCreate = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationV2UsersCreateData, ThrowOnError>
): RequestResult<IntegrationV2UsersCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    IntegrationV2UsersCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      { name: 'Saas-secret-token', type: 'apiKey' },
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/users/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * User
 */
export const integrationV2UsersRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2UsersRetrieveData, ThrowOnError>
): RequestResult<IntegrationV2UsersRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    IntegrationV2UsersRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      { name: 'Saas-secret-token', type: 'apiKey' },
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/integration/v2/users/{sso_id}/',
    ...options
  })

/**
 * User
 */
export const integrationV2UsersPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2UsersPartialUpdateData, ThrowOnError>
): RequestResult<
  IntegrationV2UsersPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    IntegrationV2UsersPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/users/{sso_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Invite users into the organization of the application making the call.
 */
export const integrationV2UsersInviteCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationV2UsersInviteCreateData, ThrowOnError>
): RequestResult<
  IntegrationV2UsersInviteCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IntegrationV2UsersInviteCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/integration/v2/users/invite/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const internalGoogleMailTokenCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalGoogleMailTokenCreateData, ThrowOnError>
): RequestResult<
  InternalGoogleMailTokenCreateResponses,
  InternalGoogleMailTokenCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    InternalGoogleMailTokenCreateResponses,
    InternalGoogleMailTokenCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/internal/google/mail/token/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const internalMcpConnectionRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalMcpConnectionRetrieveData, ThrowOnError>
): RequestResult<
  InternalMcpConnectionRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    InternalMcpConnectionRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/internal/mcp/connections/{cid}/',
    ...options
  })

export const internalMicrosoftGraphTokenCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalMicrosoftGraphTokenCreateData, ThrowOnError>
): RequestResult<
  InternalMicrosoftGraphTokenCreateResponses,
  InternalMicrosoftGraphTokenCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    InternalMicrosoftGraphTokenCreateResponses,
    InternalMicrosoftGraphTokenCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/internal/microsoft/graph/token/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const internalPublicAccessCredentialsSnapshotRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    InternalPublicAccessCredentialsSnapshotRetrieveData,
    ThrowOnError
  >
): RequestResult<
  InternalPublicAccessCredentialsSnapshotRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    InternalPublicAccessCredentialsSnapshotRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/internal/public-access/credentials/{credential_id}/snapshot/',
    ...options
  })

export const internalPublicAccessCredentialsUsageCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalPublicAccessCredentialsUsageCreateData, ThrowOnError>
): RequestResult<
  InternalPublicAccessCredentialsUsageCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    InternalPublicAccessCredentialsUsageCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/internal/public-access/credentials/{credential_id}/usage/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * The caller's own connections in the organization, of every status, newest first.
 */
export const mcpMyConnectionsList = <ThrowOnError extends boolean = false>(
  options: Options<McpMyConnectionsListData, ThrowOnError>
): RequestResult<McpMyConnectionsListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    McpMyConnectionsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mcp-access/me/connections/',
    ...options
  })

export const mcpMyConnectionsRevoke = <ThrowOnError extends boolean = false>(
  options: Options<McpMyConnectionsRevokeData, ThrowOnError>
): RequestResult<McpMyConnectionsRevokeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    McpMyConnectionsRevokeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mcp-access/me/connections/{id}/revoke/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Replaces the scopes of one of the caller's active connections.
 */
export const mcpMyConnectionsScopesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<McpMyConnectionsScopesUpdateData, ThrowOnError>
): RequestResult<
  McpMyConnectionsScopesUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).put<
    McpMyConnectionsScopesUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mcp-access/me/connections/{id}/scopes/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Services the caller can access in the organization; `can_manage` gates Account's admin tabs.
 */
export const mcpMyServicesList = <ThrowOnError extends boolean = false>(
  options: Options<McpMyServicesListData, ThrowOnError>
): RequestResult<McpMyServicesListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    McpMyServicesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mcp-access/me/services/',
    ...options
  })

/**
 * Allowed on every enabled service the caller can access. The token is returned once.
 */
export const mcpPersonalTokensCreate = <ThrowOnError extends boolean = false>(
  options: Options<McpPersonalTokensCreateData, ThrowOnError>
): RequestResult<McpPersonalTokensCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    McpPersonalTokensCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mcp-access/me/tokens/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * ``GET /mcp/tools/`` — list of tool descriptors for ai-service.
 *
 * For an agent-originated (delegated) token the list is filtered to the tools
 * the agent∩user intersection would actually allow, so the agent's toolset
 * reflects its capabilities. A direct user call is unfiltered.
 */
export const mcpToolsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<McpToolsRetrieveData, ThrowOnError>
): RequestResult<McpToolsRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    McpToolsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mcp/tools/',
    ...options
  })

/**
 * ``POST /mcp/tools/<name>/call/`` — invoke a tool as the bearer-authenticated user.
 *
 * Request body: ``{"args": {...}}`` (or empty). Response shape mirrors MCP:
 * - success: ``{"result": <dict>}``
 * - error:   ``{"error": {"code": <str>, "message": <str>}}``
 *
 * Auth is the same Bearer/Token JWT used everywhere else in Core. ai-service
 * forwards the user's JWT verbatim, so each tool acts as the actual user.
 *
 * For agent-originated (delegated/OBO) tokens, ``AgentUserIntersectionPermission``
 * additionally enforces the agent∩user intersection (Story 2): the call is
 * allowed only when the acting user holds RBAC permissions in the agent
 * client's bound application. Plain user JWTs are unaffected.
 */
export const mcpToolsCallCreate = <ThrowOnError extends boolean = false>(
  options: Options<McpToolsCallCreateData, ThrowOnError>
): RequestResult<McpToolsCallCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    McpToolsCallCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mcp/tools/{tool_name}/call/',
    ...options
  })

/**
 * MFA configuration for the authenticated user.
 */
export const mfaConfigRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<MfaConfigRetrieveData, ThrowOnError>
): RequestResult<MfaConfigRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    MfaConfigRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/config/',
    ...options
  })

/**
 * MFA configuration for the authenticated user.
 */
export const mfaConfigPartialUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<MfaConfigPartialUpdateData, ThrowOnError>
): RequestResult<MfaConfigPartialUpdateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).patch<
    MfaConfigPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/config/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * MFA configuration for the authenticated user.
 */
export const mfaConfigUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<MfaConfigUpdateData, ThrowOnError>
): RequestResult<MfaConfigUpdateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).put<
    MfaConfigUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/config/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Download MFA backup codes as CSV.
 */
export const mfaConfigDownloadBackupCodesCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<MfaConfigDownloadBackupCodesCreateData, ThrowOnError>
): RequestResult<
  MfaConfigDownloadBackupCodesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    MfaConfigDownloadBackupCodesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/config/download-backup-codes/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Generate new backup codes for MFA.
 */
export const mfaConfigGenerateBackupCodesCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<MfaConfigGenerateBackupCodesCreateData, ThrowOnError>
): RequestResult<
  MfaConfigGenerateBackupCodesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    MfaConfigGenerateBackupCodesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/config/generate-backup-codes/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Internal endpoint that lists MFA audit events from the shared audit log.
 *
 * Filters, pagination, and serialization reuse :mod:`skalx_audit_log.reader`
 * so this endpoint stays consistent with the primary ``/audit-logs/`` reader.
 *
 * @deprecated
 */
export const mfaInternalAuditLogsList = <ThrowOnError extends boolean = false>(
  options?: Options<MfaInternalAuditLogsListData, ThrowOnError>
): RequestResult<MfaInternalAuditLogsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    MfaInternalAuditLogsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mfa/internal/audit-logs/',
    ...options
  })

/**
 * Removed. The legacy CSV/XLSX-to-email export flow was retired when MFA events moved to the shared audit-log feed. This URL is kept only to surface a clear 410 to any remaining consumer — please contact the main-saas team so we can plan a replacement.
 *
 * @deprecated
 */
export const mfaInternalAuditLogsExportCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<MfaInternalAuditLogsExportCreateData, ThrowOnError>
): RequestResult<
  MfaInternalAuditLogsExportCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MfaInternalAuditLogsExportCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mfa/internal/audit-logs/export/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsList = <ThrowOnError extends boolean = false>(
  options?: Options<MfaInternalConfigsListData, ThrowOnError>
): RequestResult<MfaInternalConfigsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    MfaInternalConfigsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mfa/internal/configs/',
    ...options
  })

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<MfaInternalConfigsRetrieveData, ThrowOnError>
): RequestResult<MfaInternalConfigsRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    MfaInternalConfigsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mfa/internal/configs/{id}/',
    ...options
  })

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<MfaInternalConfigsPartialUpdateData, ThrowOnError>
): RequestResult<
  MfaInternalConfigsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    MfaInternalConfigsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mfa/internal/configs/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<MfaInternalConfigsUpdateData, ThrowOnError>
): RequestResult<MfaInternalConfigsUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<
    MfaInternalConfigsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mfa/internal/configs/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Internal endpoint for MFA lockouts.
 */
export const mfaInternalLockoutsList = <ThrowOnError extends boolean = false>(
  options?: Options<MfaInternalLockoutsListData, ThrowOnError>
): RequestResult<MfaInternalLockoutsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    MfaInternalLockoutsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/mfa/internal/lockouts/',
    ...options
  })

/**
 * Internal endpoint for MFA lockouts.
 */
export const mfaInternalLockoutsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<MfaInternalLockoutsDestroyData, ThrowOnError>
): RequestResult<MfaInternalLockoutsDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    MfaInternalLockoutsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/mfa/internal/lockouts/{id}/', ...options })

/**
 * Send OTP code to the user.
 */
export const mfaSendOtpCreate = <ThrowOnError extends boolean = false>(
  options?: Options<MfaSendOtpCreateData, ThrowOnError>
): RequestResult<MfaSendOtpCreateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    MfaSendOtpCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'MFAJWTAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/send-otp/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Manage trusted devices.
 */
export const mfaTrustedDevicesList = <ThrowOnError extends boolean = false>(
  options?: Options<MfaTrustedDevicesListData, ThrowOnError>
): RequestResult<MfaTrustedDevicesListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    MfaTrustedDevicesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/trusted-devices/',
    ...options
  })

/**
 * Manage trusted devices.
 */
export const mfaTrustedDevicesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<MfaTrustedDevicesDestroyData, ThrowOnError>
): RequestResult<MfaTrustedDevicesDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    MfaTrustedDevicesDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/trusted-devices/{id}/',
    ...options
  })

/**
 * Manage trusted devices.
 */
export const mfaTrustedDevicesDeleteAllDestroy = <
  ThrowOnError extends boolean = false
>(
  options?: Options<MfaTrustedDevicesDeleteAllDestroyData, ThrowOnError>
): RequestResult<
  MfaTrustedDevicesDeleteAllDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).delete<
    MfaTrustedDevicesDeleteAllDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/trusted-devices/delete-all/',
    ...options
  })

/**
 * Verify backup code and issue tokens.
 */
export const mfaVerifyBackupCodeCreate = <ThrowOnError extends boolean = false>(
  options: Options<MfaVerifyBackupCodeCreateData, ThrowOnError>
): RequestResult<MfaVerifyBackupCodeCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    MfaVerifyBackupCodeCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'MFAJWTAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/verify-backup-code/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Verify OTP code and issue full tokens.
 */
export const mfaVerifyOtpCreate = <ThrowOnError extends boolean = false>(
  options: Options<MfaVerifyOtpCreateData, ThrowOnError>
): RequestResult<MfaVerifyOtpCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    MfaVerifyOtpCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'MFAJWTAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/mfa/verify-otp/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Report a step of the calling application: done, failed, back to todo, or reset for the whole workspace after its data was wiped.
 */
export const onboardingInternalStepsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OnboardingInternalStepsCreateData, ThrowOnError>
): RequestResult<
  OnboardingInternalStepsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OnboardingInternalStepsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [{ name: 'Saas-secret-token', type: 'apiKey' }],
    url: '/onboarding/internal/steps/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Current user's journey for a scope: the steps the client has reported, plus cross-links.
 */
export const onboardingJourneysRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OnboardingJourneysRetrieveData, ThrowOnError>
): RequestResult<OnboardingJourneysRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    OnboardingJourneysRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/onboarding/journeys/{scope}/',
    ...options
  })

/**
 * Report a step's status (set_step) or a checklist intent: skip, dismiss, hide, expand, collapse.
 */
export const onboardingJourneysPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OnboardingJourneysPartialUpdateData, ThrowOnError>
): RequestResult<
  OnboardingJourneysPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OnboardingJourneysPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/onboarding/journeys/{scope}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * The workspace's onboarding profile — the only personalisation input an app may read. Requires workspace permission: `organization.view`.
 */
export const onboardingProfileRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<OnboardingProfileRetrieveData, ThrowOnError>
): RequestResult<OnboardingProfileRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    OnboardingProfileRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/onboarding/profile/',
    ...options
  })

/**
 * Fill in what the wizard collects after provisioning has started — attribution, in practice. Requires workspace permission: `organization.manage`.
 */
export const onboardingProfilePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<OnboardingProfilePartialUpdateData, ThrowOnError>
): RequestResult<
  OnboardingProfilePartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).patch<
    OnboardingProfilePartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/onboarding/profile/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Save the workspace intent profile. Requires workspace permission: `organization.manage`; a second call returns the existing profile (BR-14).
 */
export const onboardingProfileCreate = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingProfileCreateData, ThrowOnError>
): RequestResult<
  OnboardingProfileCreateResponses,
  OnboardingProfileCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OnboardingProfileCreateResponses,
    OnboardingProfileCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/onboarding/profile/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditArchivesList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAuditArchivesListData, ThrowOnError>
): RequestResult<
  OrganizationsAuditArchivesListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAuditArchivesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-archives/',
    ...options
  })

/**
 * Requires workspace permission: `audit.export`.
 */
export const organizationsAuditArchivesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAuditArchivesCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAuditArchivesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAuditArchivesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-archives/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `audit.export`.
 */
export const organizationsAuditArchivesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAuditArchivesDestroyData, ThrowOnError>
): RequestResult<
  OrganizationsAuditArchivesDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OrganizationsAuditArchivesDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-archives/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditArchivesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAuditArchivesRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsAuditArchivesRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAuditArchivesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-archives/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `audit.export`.
 */
export const organizationsAuditArchivesDownloadRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAuditArchivesDownloadRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsAuditArchivesDownloadRetrieveResponses,
  OrganizationsAuditArchivesDownloadRetrieveErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAuditArchivesDownloadRetrieveResponses,
    OrganizationsAuditArchivesDownloadRetrieveErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-archives/{id}/download/',
    ...options
  })

/**
 * Requires workspace permission: `audit.export`.
 */
export const organizationsAuditArchivesBulkDeleteDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsAuditArchivesBulkDeleteDestroyData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsAuditArchivesBulkDeleteDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OrganizationsAuditArchivesBulkDeleteDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-archives/bulk-delete/',
    ...options
  })

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAuditLogsListData, ThrowOnError>
): RequestResult<OrganizationsAuditLogsListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsAuditLogsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-logs/',
    ...options
  })

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAuditLogsRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsAuditLogsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAuditLogsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-logs/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsFiltersRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAuditLogsFiltersRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsAuditLogsFiltersRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAuditLogsFiltersRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-logs/filters/',
    ...options
  })

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsSignInActivityRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsAuditLogsSignInActivityRetrieveData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsAuditLogsSignInActivityRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAuditLogsSignInActivityRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/audit-logs/sign-in-activity/',
    ...options
  })

/**
 * Requests to join this workspace. Requires workspace permission: `users.invite`.
 */
export const organizationsJoinRequestsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsJoinRequestsListData, ThrowOnError>
): RequestResult<
  OrganizationsJoinRequestsListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsJoinRequestsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/join-requests/',
    ...options
  })

/**
 * Ask to join the workspace that uses your email domain (BR-10). Notifies its administrators and never grants membership. Asking twice returns the same request.
 */
export const organizationsJoinRequestsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsJoinRequestsCreateData, ThrowOnError>
): RequestResult<
  OrganizationsJoinRequestsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsJoinRequestsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/join-requests/',
    ...options
  })

/**
 * Approve a request: grants Member workspace access and tells the person. Requires workspace permission: `users.invite`.
 */
export const organizationsJoinRequestsApproveCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsJoinRequestsApproveCreateData, ThrowOnError>
): RequestResult<
  OrganizationsJoinRequestsApproveCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsJoinRequestsApproveCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/join-requests/{id}/approve/',
    ...options
  })

/**
 * Decline a request. Nothing is granted and the requester is not emailed. Requires workspace permission: `users.invite`.
 */
export const organizationsJoinRequestsRejectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsJoinRequestsRejectCreateData, ThrowOnError>
): RequestResult<
  OrganizationsJoinRequestsRejectCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsJoinRequestsRejectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/{organization_id}/join-requests/{id}/reject/',
    ...options
  })

/**
 * Requires `users.view` to list all workspace members; without it, the caller receives only their own membership.
 */
export const organizationsAccessList = <ThrowOnError extends boolean = false>(
  options?: Options<OrganizationsAccessListData, ThrowOnError>
): RequestResult<OrganizationsAccessListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    OrganizationsAccessListResponses,
    unknown,
    ThrowOnError
  >({
    querySerializer: {
      parameters: { user_preference: { array: { explode: false } } }
    },
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/',
    ...options
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessDestroyData, ThrowOnError>
): RequestResult<OrganizationsAccessDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    OrganizationsAccessDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsAccessRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessRetrieveData, ThrowOnError>
): RequestResult<OrganizationsAccessRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsAccessRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessPartialUpdateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsAccessPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessBlockCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessBlockCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessBlockCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessBlockCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/block/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Lift THIS workspace's per-member MFA compulsion (counterpart to require-mfa).
 *
 * Clears the org-scoped ``require_mfa`` override on the member's access record for this organization. It does NOT switch off the member's own MFA enrollment — that is the member's to manage, and an admin recovery for a lost factor is ``reset-mfa`` (which never exposes their codes). A workspace-wide ``Organization.require_mfa`` policy, if set, still applies; this only removes the per-member override.
 *
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessDisableMfaCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessDisableMfaCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessDisableMfaCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessDisableMfaCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/disable-mfa/',
    ...options
  })

/**
 * Issue a session for the target member. Requires workspace permission `users.manage` AND the workspace owner role; superusers are exempt, and impersonating another admin is always refused.
 */
export const organizationsAccessImpersonateCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessImpersonateCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessImpersonateCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessImpersonateCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/impersonate/',
    ...options
  })

/**
 * Compel MFA for a member in THIS workspace (org-scoped enforcement).
 *
 * Sets the per-member ``require_mfa`` flag on the member's access record for this organization only — it never touches the member's account-global MFA enrollment, so enforcing MFA here cannot change their security posture in another workspace (fixes the cross-workspace leak, MFA-1). If the member hasn't enrolled a usable method yet, the login gate drives enrollment-at-login rather than locking them out.
 *
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessRequireMfaCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessRequireMfaCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessRequireMfaCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessRequireMfaCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/require-mfa/',
    ...options
  })

/**
 * Re-issue a pending invite's token and email the member a fresh link. Requires workspace permission: `users.invite`.
 */
export const organizationsAccessResendInviteCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessResendInviteCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessResendInviteCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessResendInviteCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/resend-invite/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Reset a member's MFA to a clean slate (admin recovery — lost or compromised second factor) WITHOUT exposing their recovery codes.
 *
 * Recovery operates on the member's own (account-global) enrollment, since a second factor is per-user: the old backup codes, trusted devices, and lockouts are invalidated so the member re-enrolls cleanly, and the email-OTP fallback is (re)enabled via the shared safe-enablement helper so the reset can never lock them out. It only ever *strengthens* the member's posture — it cannot disable MFA in any workspace. The admin never sees a code.
 *
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessResetMfaCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessResetMfaCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessResetMfaCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessResetMfaCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/reset-mfa/',
    ...options
  })

/**
 * Admin-triggered password reset — emails the member a reset link.
 *
 * Link-based (not a temporary password) to stay consistent with the rest of the auth flows and avoid mailing a plaintext secret.
 *
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessResetPasswordCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessResetPasswordCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessResetPasswordCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessResetPasswordCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/reset-password/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Cancel a still-pending invite — deletes the token and marks it revoked. Requires workspace permission: `users.invite`.
 */
export const organizationsAccessRevokeInviteCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessRevokeInviteCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessRevokeInviteCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessRevokeInviteCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/revoke-invite/',
    ...options
  })

/**
 * Replace personal roles assigned to a user in an organization.
 *
 * Admin/Member may be changed through the same role-ID list as application and custom workspace roles. Omitting a system role preserves the current Admin/Member assignment. Group-derived grants are always left untouched.
 *
 * Changing application roles requires `applications.access`; changing custom workspace roles requires `roles.manage`; changing system workspace roles requires a workspace administrator.
 */
export const organizationsAccessRolesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessRolesCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessRolesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessRolesCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/roles/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * List a member's active sign-in sessions scoped to this workspace. Requires workspace permission: `users.manage`.
 */
export const organizationsAccessSessionsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessSessionsListData, ThrowOnError>
): RequestResult<
  OrganizationsAccessSessionsListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAccessSessionsListResponses,
    unknown,
    ThrowOnError
  >({
    querySerializer: {
      parameters: { user_preference: { array: { explode: false } } }
    },
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/sessions/',
    ...options
  })

/**
 * Revoke a single session of a member (scoped to this workspace). Requires workspace permission: `users.manage`.
 */
export const organizationsAccessSessionsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessSessionsDestroyData, ThrowOnError>
): RequestResult<
  OrganizationsAccessSessionsDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OrganizationsAccessSessionsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/sessions/{jti}/',
    ...options
  })

/**
 * Revoke every active session of a member within this workspace. Requires workspace permission: `users.manage`.
 */
export const organizationsAccessSessionsRevokeAllCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessSessionsRevokeAllCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessSessionsRevokeAllCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessSessionsRevokeAllCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/sessions/revoke-all/',
    ...options
  })

/**
 * Count a member's successful sign-ins over the trailing 30 days (audit-log backed). Requires workspace permission: `audit.view`.
 */
export const organizationsAccessSignInActivityRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessSignInActivityRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsAccessSignInActivityRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAccessSignInActivityRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/{id}/sign-in-activity/',
    ...options
  })

/**
 * Requires workspace permission: `users.invite`.
 */
export const organizationsAccessAddCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessAddCreateData, ThrowOnError>
): RequestResult<
  OrganizationsAccessAddCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsAccessAddCreateResponses,
    unknown,
    ThrowOnError
  >({
    querySerializer: {
      parameters: { user_preference: { array: { explode: false } } }
    },
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/add/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Returns the organigrama (organization chart) for a given organization and optional head_user. Query params: - organization: int (required) - head_user: int (optional) Requires workspace permission: `users.view`.
 */
export const organizationsAccessOrganigramaList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsAccessOrganigramaListData, ThrowOnError>
): RequestResult<
  OrganizationsAccessOrganigramaListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsAccessOrganigramaListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/access/organigrama/',
    ...options
  })

/**
 * Live, public check of whether a workspace address can be claimed.
 *
 * Mirrors the create path (reserved list, then uniqueness). A reserved slug reads as
 * unavailable — unlike probing ``/organizations/info`` for a 404, which had no record
 * for a reserved slug and so reported it free.
 */
export const organizationsDomainAvailabilityRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsDomainAvailabilityRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsDomainAvailabilityRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsDomainAvailabilityRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/domain-availability/',
    ...options
  })

/**
 * Whether an existing workspace uses the caller's email domain, and whether they already asked.
 */
export const organizationsDomainMatchRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<OrganizationsDomainMatchRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsDomainMatchRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    OrganizationsDomainMatchRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/domain-match/',
    ...options
  })

export const organizationsInfoRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsInfoRetrieveData, ThrowOnError>
): RequestResult<OrganizationsInfoRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsInfoRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/info/{domain_name}/',
    ...options
  })

/**
 * Returns workspaces where the caller has `organization.view`.
 */
export const organizationsOrganizationsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<OrganizationsOrganizationsListData, ThrowOnError>
): RequestResult<
  OrganizationsOrganizationsListResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    OrganizationsOrganizationsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/',
    ...options
  })

/**
 * Requires authentication; no existing workspace permission is required.
 */
export const organizationsOrganizationsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsOrganizationsCreateData, ThrowOnError>
): RequestResult<
  OrganizationsOrganizationsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsOrganizationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission `organization.manage` and the workspace owner role.
 */
export const organizationsOrganizationsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsOrganizationsDestroyData, ThrowOnError>
): RequestResult<
  OrganizationsOrganizationsDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OrganizationsOrganizationsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsOrganizationsRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsOrganizationsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsOrganizationsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsOrganizationsPartialUpdateData, ThrowOnError>
): RequestResult<
  OrganizationsOrganizationsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsOrganizationsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsAuthMethodsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsAuthMethodsRetrieveData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsAuthMethodsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsOrganizationsAuthMethodsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/auth-methods/',
    ...options
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsAuthMethodsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsAuthMethodsPartialUpdateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsAuthMethodsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsOrganizationsAuthMethodsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/auth-methods/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsCustomAuthProvidersList = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsCustomAuthProvidersListData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsCustomAuthProvidersListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsOrganizationsCustomAuthProvidersListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/custom-auth-providers/',
    ...options
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsCustomAuthProvidersCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsCustomAuthProvidersCreateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsCustomAuthProvidersCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsOrganizationsCustomAuthProvidersCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/custom-auth-providers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsCustomAuthProvidersDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsCustomAuthProvidersDestroyData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsCustomAuthProvidersDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OrganizationsOrganizationsCustomAuthProvidersDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/custom-auth-providers/{provider_id}/',
    ...options
  })

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsCustomAuthProvidersRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsCustomAuthProvidersRetrieveData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsCustomAuthProvidersRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsOrganizationsCustomAuthProvidersRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/custom-auth-providers/{provider_id}/',
    ...options
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsCustomAuthProvidersPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsCustomAuthProvidersPartialUpdateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsCustomAuthProvidersPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsOrganizationsCustomAuthProvidersPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/custom-auth-providers/{provider_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsDemoDisableCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsDemoDisableCreateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsDemoDisableCreateResponses,
  OrganizationsOrganizationsDemoDisableCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsOrganizationsDemoDisableCreateResponses,
    OrganizationsOrganizationsDemoDisableCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/demo/disable/',
    ...options
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsDemoEnableCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsOrganizationsDemoEnableCreateData, ThrowOnError>
): RequestResult<
  OrganizationsOrganizationsDemoEnableCreateResponses,
  OrganizationsOrganizationsDemoEnableCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsOrganizationsDemoEnableCreateResponses,
    OrganizationsOrganizationsDemoEnableCreateErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/demo/enable/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsEnvironmentBuildCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsEnvironmentBuildCreateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsEnvironmentBuildCreateResponses,
  OrganizationsOrganizationsEnvironmentBuildCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsOrganizationsEnvironmentBuildCreateResponses,
    OrganizationsOrganizationsEnvironmentBuildCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/environment/build/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsEnvironmentClearCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsEnvironmentClearCreateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsEnvironmentClearCreateResponses,
  OrganizationsOrganizationsEnvironmentClearCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsOrganizationsEnvironmentClearCreateResponses,
    OrganizationsOrganizationsEnvironmentClearCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/environment/clear/',
    ...options
  })

/**
 * Return enabled auth methods for the organization (member-accessible, no secrets). Requires an active membership in the workspace; no workspace permission is required.
 */
export const organizationsOrganizationsMemberAuthMethodsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsMemberAuthMethodsListData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsMemberAuthMethodsListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsOrganizationsMemberAuthMethodsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/member-auth-methods/',
    ...options
  })

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsMicrosoftAppRegistrationRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/microsoft/app-registration/',
    ...options
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsMicrosoftAppRegistrationPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/microsoft/app-registration/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission `organization.manage` and the current workspace owner role.
 */
export const organizationsOrganizationsTransferOwnershipCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsOrganizationsTransferOwnershipCreateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsOrganizationsTransferOwnershipCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsOrganizationsTransferOwnershipCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/organizations/{id}/transfer-ownership/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires authentication; no workspace permission is required.
 */
export const permissionsList = <ThrowOnError extends boolean = false>(
  options?: Options<PermissionsListData, ThrowOnError>
): RequestResult<PermissionsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    PermissionsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/permissions/',
    ...options
  })

/**
 * Requires a workspace administrator.
 */
export const permissionsCreate = <ThrowOnError extends boolean = false>(
  options: Options<PermissionsCreateData, ThrowOnError>
): RequestResult<PermissionsCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    PermissionsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/permissions/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires a workspace administrator.
 */
export const permissionsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<PermissionsDestroyData, ThrowOnError>
): RequestResult<PermissionsDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    PermissionsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/permissions/{id}/',
    ...options
  })

/**
 * Requires authentication; no workspace permission is required.
 */
export const permissionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<PermissionsRetrieveData, ThrowOnError>
): RequestResult<PermissionsRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    PermissionsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/permissions/{id}/',
    ...options
  })

/**
 * Requires a workspace administrator.
 */
export const permissionsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PermissionsPartialUpdateData, ThrowOnError>
): RequestResult<PermissionsPartialUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    PermissionsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/permissions/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Returns the list of permissions for the authenticated user in the specified organization.
 *
 * Permission resolution: - Admin roles (is_admin=True): Grant ALL permissions for their application scope * role.application set → ALL permissions for that application * role.application null → ALL organization-level permissions - Regular roles: Only explicitly assigned permissions - Multiple roles: Union of all permissions (deduplicated)
 *
 * Respects application_repository query filter if provided.
 *
 * Requires authentication; no workspace permission is required.
 */
export const organizationsPermissionsUserList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsPermissionsUserListData, ThrowOnError>
): RequestResult<
  OrganizationsPermissionsUserListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsPermissionsUserListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/permissions/user/',
    ...options
  })

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesList = <ThrowOnError extends boolean = false>(
  options?: Options<OrganizationsRolesListData, ThrowOnError>
): RequestResult<OrganizationsRolesListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    OrganizationsRolesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/roles/',
    ...options
  })

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsRolesCreateData, ThrowOnError>
): RequestResult<OrganizationsRolesCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    OrganizationsRolesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/roles/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsRolesDestroyData, ThrowOnError>
): RequestResult<OrganizationsRolesDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    OrganizationsRolesDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/roles/{id}/',
    ...options
  })

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsRolesRetrieveData, ThrowOnError>
): RequestResult<OrganizationsRolesRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsRolesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/roles/{id}/',
    ...options
  })

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsRolesPartialUpdateData, ThrowOnError>
): RequestResult<
  OrganizationsRolesPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsRolesPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/roles/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Replace all users with this role to another role in the same organization. Requires a workspace administrator.
 */
export const organizationsRolesReplaceCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsRolesReplaceCreateData, ThrowOnError>
): RequestResult<
  OrganizationsRolesReplaceCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsRolesReplaceCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/roles/{id}/replace/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.view`.
 */
export const organizationsTeamUsersList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<OrganizationsTeamUsersListData, ThrowOnError>
): RequestResult<OrganizationsTeamUsersListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    OrganizationsTeamUsersListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/team-users/',
    ...options
  })

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.manage`.
 */
export const organizationsTeamUsersCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsTeamUsersCreateData, ThrowOnError>
): RequestResult<
  OrganizationsTeamUsersCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsTeamUsersCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/team-users/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.manage`.
 */
export const organizationsTeamUsersDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsTeamUsersDestroyData, ThrowOnError>
): RequestResult<
  OrganizationsTeamUsersDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OrganizationsTeamUsersDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/team-users/{id}/',
    ...options
  })

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.view`.
 */
export const organizationsTeamUsersRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsTeamUsersRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsTeamUsersRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsTeamUsersRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/team-users/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsTeamsList = <ThrowOnError extends boolean = false>(
  options?: Options<OrganizationsTeamsListData, ThrowOnError>
): RequestResult<OrganizationsTeamsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    OrganizationsTeamsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/teams/',
    ...options
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsTeamsCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsTeamsCreateData, ThrowOnError>
): RequestResult<OrganizationsTeamsCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    OrganizationsTeamsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/teams/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsTeamsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsTeamsDestroyData, ThrowOnError>
): RequestResult<OrganizationsTeamsDestroyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    OrganizationsTeamsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/teams/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsTeamsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsTeamsRetrieveData, ThrowOnError>
): RequestResult<OrganizationsTeamsRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationsTeamsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/teams/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsTeamsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsTeamsPartialUpdateData, ThrowOnError>
): RequestResult<
  OrganizationsTeamsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsTeamsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/teams/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsTeamsOrganigramList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsTeamsOrganigramListData, ThrowOnError>
): RequestResult<
  OrganizationsTeamsOrganigramListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsTeamsOrganigramListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/teams/organigram/',
    ...options
  })

/**
 * Requires workspace permission: `groups.view`.
 */
export const organizationsUserGroupsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<OrganizationsUserGroupsListData, ThrowOnError>
): RequestResult<OrganizationsUserGroupsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    OrganizationsUserGroupsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/user-groups/',
    ...options
  })

/**
 * Requires workspace permission: `groups.manage`.
 */
export const organizationsUserGroupsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsUserGroupsCreateData, ThrowOnError>
): RequestResult<
  OrganizationsUserGroupsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsUserGroupsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/user-groups/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `groups.manage`.
 */
export const organizationsUserGroupsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsUserGroupsDestroyData, ThrowOnError>
): RequestResult<
  OrganizationsUserGroupsDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OrganizationsUserGroupsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/user-groups/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `groups.view`.
 */
export const organizationsUserGroupsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsUserGroupsRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsUserGroupsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsUserGroupsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/user-groups/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `groups.manage`.
 */
export const organizationsUserGroupsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsUserGroupsPartialUpdateData, ThrowOnError>
): RequestResult<
  OrganizationsUserGroupsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsUserGroupsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/user-groups/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Replace the roles this group grants within one application.
 *
 * People → Groups inside an app only shows that app's roles, so replacing the whole-group set from there would drop the roles of every other app.
 *
 * Requires workspace permission: `groups.manage`.
 */
export const organizationsUserGroupsApplicationsRolesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OrganizationsUserGroupsApplicationsRolesPartialUpdateData,
    ThrowOnError
  >
): RequestResult<
  OrganizationsUserGroupsApplicationsRolesPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsUserGroupsApplicationsRolesPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/user-groups/{id}/applications/{application_id}/roles/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const organizationsValidateRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsValidateRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsValidateRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsValidateRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/validate/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `roles.view`.
 */
export const organizationsWorkspacePermissionsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsWorkspacePermissionsListData, ThrowOnError>
): RequestResult<
  OrganizationsWorkspacePermissionsListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsWorkspacePermissionsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/workspace-permissions/',
    ...options
  })

/**
 * Requires workspace permission: `roles.view`.
 */
export const organizationsWorkspaceRolesList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsWorkspaceRolesListData, ThrowOnError>
): RequestResult<
  OrganizationsWorkspaceRolesListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsWorkspaceRolesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/workspace-roles/',
    ...options
  })

/**
 * Workspace-only roles; application roles are deliberately excluded. Requires workspace permission: `roles.manage`.
 */
export const organizationsWorkspaceRolesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsWorkspaceRolesCreateData, ThrowOnError>
): RequestResult<
  OrganizationsWorkspaceRolesCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizationsWorkspaceRolesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/workspace-roles/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Workspace-only roles; application roles are deliberately excluded. Requires workspace permission: `roles.manage`.
 */
export const organizationsWorkspaceRolesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsWorkspaceRolesDestroyData, ThrowOnError>
): RequestResult<
  OrganizationsWorkspaceRolesDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OrganizationsWorkspaceRolesDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/workspace-roles/{id}/',
    ...options
  })

/**
 * Workspace-only roles; application roles are deliberately excluded. Requires workspace permission: `roles.view`.
 */
export const organizationsWorkspaceRolesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsWorkspaceRolesRetrieveData, ThrowOnError>
): RequestResult<
  OrganizationsWorkspaceRolesRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OrganizationsWorkspaceRolesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/workspace-roles/{id}/',
    ...options
  })

/**
 * Workspace-only roles; application roles are deliberately excluded. Requires workspace permission: `roles.manage`.
 */
export const organizationsWorkspaceRolesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OrganizationsWorkspaceRolesPartialUpdateData, ThrowOnError>
): RequestResult<
  OrganizationsWorkspaceRolesPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    OrganizationsWorkspaceRolesPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/organizations/workspace-roles/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const schemaRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<SchemaRetrieveData, ThrowOnError>
): RequestResult<SchemaRetrieveResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    SchemaRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/schema',
    ...options
  })

/**
 * Requires workspace permission: `applications.view`. Connections of every status, newest first.
 */
export const mcpConnectionsList = <ThrowOnError extends boolean = false>(
  options: Options<McpConnectionsListData, ThrowOnError>
): RequestResult<McpConnectionsListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    McpConnectionsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/mcp/{organization_id}/connections/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const mcpConnectionsRevoke = <ThrowOnError extends boolean = false>(
  options: Options<McpConnectionsRevokeData, ThrowOnError>
): RequestResult<McpConnectionsRevokeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    McpConnectionsRevokeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/mcp/{organization_id}/connections/{id}/revoke/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`. Replaces an active connection's scopes.
 */
export const mcpConnectionsScopesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<McpConnectionsScopesUpdateData, ThrowOnError>
): RequestResult<McpConnectionsScopesUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<
    McpConnectionsScopesUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/mcp/{organization_id}/connections/{id}/scopes/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.view`.
 */
export const mcpPoliciesList = <ThrowOnError extends boolean = false>(
  options: Options<McpPoliciesListData, ThrowOnError>
): RequestResult<McpPoliciesListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    McpPoliciesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/mcp/{organization_id}/policies/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`. Disabling the service revokes every connection of it.
 */
export const mcpPoliciesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<McpPoliciesPartialUpdateData, ThrowOnError>
): RequestResult<
  McpPoliciesPartialUpdateResponses,
  McpPoliciesPartialUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    McpPoliciesPartialUpdateResponses,
    McpPoliciesPartialUpdateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/mcp/{organization_id}/policies/{service}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Filter with `managed_by` / `managed_ref` (exact match) to find the webhook another service manages, e.g. `?managed_by=squad&managed_ref=agent:<uuid>`.
 *
 * Requires workspace permission: `applications.view`.
 */
export const settingsOutboundWebhooksWebhooksList = <
  ThrowOnError extends boolean = false
>(
  options: Options<SettingsOutboundWebhooksWebhooksListData, ThrowOnError>
): RequestResult<
  SettingsOutboundWebhooksWebhooksListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SettingsOutboundWebhooksWebhooksListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/outbound-webhooks/{application_id}/webhooks/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SettingsOutboundWebhooksWebhooksCreateData, ThrowOnError>
): RequestResult<
  SettingsOutboundWebhooksWebhooksCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SettingsOutboundWebhooksWebhooksCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/outbound-webhooks/{application_id}/webhooks/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Settings CRUD for outbound webhooks.
 *
 * Saving or deleting here pushes the change to the organization's CRM instance through ``apps/integration/outbound_webhook_sync.py`` -- the viewset itself does not call CRM.
 *
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<SettingsOutboundWebhooksWebhooksDestroyData, ThrowOnError>
): RequestResult<
  SettingsOutboundWebhooksWebhooksDestroyResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    SettingsOutboundWebhooksWebhooksDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/outbound-webhooks/{application_id}/webhooks/{id}/',
    ...options
  })

/**
 * Settings CRUD for outbound webhooks.
 *
 * Saving or deleting here pushes the change to the organization's CRM instance through ``apps/integration/outbound_webhook_sync.py`` -- the viewset itself does not call CRM.
 *
 * Requires workspace permission: `applications.view`.
 */
export const settingsOutboundWebhooksWebhooksRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<SettingsOutboundWebhooksWebhooksRetrieveData, ThrowOnError>
): RequestResult<
  SettingsOutboundWebhooksWebhooksRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SettingsOutboundWebhooksWebhooksRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/outbound-webhooks/{application_id}/webhooks/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    SettingsOutboundWebhooksWebhooksPartialUpdateData,
    ThrowOnError
  >
): RequestResult<
  SettingsOutboundWebhooksWebhooksPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    SettingsOutboundWebhooksWebhooksPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/outbound-webhooks/{application_id}/webhooks/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * POST, not GET, deliberately.
 *
 * It writes an audit record, and a GET would put a secret-bearing URL into access logs, browser history and any intermediate proxy cache.
 *
 * Not rate limited: an organization holds at most a handful of webhooks, so a cap on how often the endpoint may be called would not stop anyone from collecting the whole set anyway. The audit record is what answers "who had access" after a leak.
 *
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksRevealSecretCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    SettingsOutboundWebhooksWebhooksRevealSecretCreateData,
    ThrowOnError
  >
): RequestResult<
  SettingsOutboundWebhooksWebhooksRevealSecretCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SettingsOutboundWebhooksWebhooksRevealSecretCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/outbound-webhooks/{application_id}/webhooks/{id}/reveal-secret/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Send one signed test delivery to the configured URL and report what came back.
 *
 * Rate limited, unlike reveal-secret: this one makes the server issue an outbound request to an address the caller controls, so without a cap it is a scanner with our egress.
 *
 * Always 200. The interesting outcomes -- refused URL, timeout, the consumer's own 4xx -- are the answer, not an error in this API, and the UI renders them from one shape.
 *
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksTestCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SettingsOutboundWebhooksWebhooksTestCreateData, ThrowOnError>
): RequestResult<
  SettingsOutboundWebhooksWebhooksTestCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SettingsOutboundWebhooksWebhooksTestCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/outbound-webhooks/{application_id}/webhooks/{id}/test/',
    ...options
  })

/**
 * Requires workspace permission: `applications.view`.
 */
export const settingsPublicAccessCredentialsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<SettingsPublicAccessCredentialsListData, ThrowOnError>
): RequestResult<
  SettingsPublicAccessCredentialsListResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SettingsPublicAccessCredentialsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/public-access/{organization_id}/credentials/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsPublicAccessCredentialsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SettingsPublicAccessCredentialsCreateData, ThrowOnError>
): RequestResult<
  SettingsPublicAccessCredentialsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SettingsPublicAccessCredentialsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/public-access/{organization_id}/credentials/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.view`.
 */
export const settingsPublicAccessCredentialsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<SettingsPublicAccessCredentialsRetrieveData, ThrowOnError>
): RequestResult<
  SettingsPublicAccessCredentialsRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SettingsPublicAccessCredentialsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/public-access/{organization_id}/credentials/{id}/',
    ...options
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsPublicAccessCredentialsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    SettingsPublicAccessCredentialsPartialUpdateData,
    ThrowOnError
  >
): RequestResult<
  SettingsPublicAccessCredentialsPartialUpdateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    SettingsPublicAccessCredentialsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/public-access/{organization_id}/credentials/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsPublicAccessCredentialsRevokeCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    SettingsPublicAccessCredentialsRevokeCreateData,
    ThrowOnError
  >
): RequestResult<
  SettingsPublicAccessCredentialsRevokeCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SettingsPublicAccessCredentialsRevokeCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/public-access/{organization_id}/credentials/{id}/revoke/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsPublicAccessCredentialsRotateCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    SettingsPublicAccessCredentialsRotateCreateData,
    ThrowOnError
  >
): RequestResult<
  SettingsPublicAccessCredentialsRotateCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SettingsPublicAccessCredentialsRotateCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/settings/public-access/{organization_id}/credentials/{id}/rotate/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const staticRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<StaticRetrieveData, ThrowOnError>
): RequestResult<StaticRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    StaticRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/static/{path}',
    ...options
  })

export const supportReportCreate = <ThrowOnError extends boolean = false>(
  options: Options<SupportReportCreateData, ThrowOnError>
): RequestResult<SupportReportCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    SupportReportCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/support/report/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Tickets filed by the caller in the caller's current organization.
 */
export const supportTicketsList = <ThrowOnError extends boolean = false>(
  options?: Options<SupportTicketsListData, ThrowOnError>
): RequestResult<SupportTicketsListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    SupportTicketsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/support/tickets/',
    ...options
  })

/**
 * Files a ticket. Reporter, organization and environment are taken from the session, not the body.
 */
export const supportTicketsCreate = <ThrowOnError extends boolean = false>(
  options: Options<SupportTicketsCreateData, ThrowOnError>
): RequestResult<SupportTicketsCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    SupportTicketsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/support/tickets/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const supportTicketsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<SupportTicketsRetrieveData, ThrowOnError>
): RequestResult<SupportTicketsRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    SupportTicketsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/support/tickets/{ticket_id}/',
    ...options
  })

export const supportTicketsCommentsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<SupportTicketsCommentsListData, ThrowOnError>
): RequestResult<SupportTicketsCommentsListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    SupportTicketsCommentsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/support/tickets/{ticket_id}/comments/',
    ...options
  })

export const supportTicketsCommentsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SupportTicketsCommentsCreateData, ThrowOnError>
): RequestResult<
  SupportTicketsCommentsCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SupportTicketsCommentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/support/tickets/{ticket_id}/comments/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * How many of the caller's tickets changed in ClickUp since the caller last opened them.
 */
export const supportTicketsUnseenCountRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<SupportTicketsUnseenCountRetrieveData, ThrowOnError>
): RequestResult<
  SupportTicketsUnseenCountRetrieveResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SupportTicketsUnseenCountRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/support/tickets/unseen-count/',
    ...options
  })

/**
 * Mints a presigned PUT the browser uploads a ticket attachment to directly, returning the id to pass back in attachment_ids when filing the ticket. The PUT must send `Content-Type` equal to the returned `content_type`: it is part of the signature, so a different or missing header is rejected by the storage.
 */
export const supportTicketsUploadsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SupportTicketsUploadsCreateData, ThrowOnError>
): RequestResult<SupportTicketsUploadsCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    SupportTicketsUploadsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/support/tickets/uploads/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Returns users who share a workspace with the caller; no workspace permission is required.
 */
export const usersList = <ThrowOnError extends boolean = false>(
  options?: Options<UsersListData, ThrowOnError>
): RequestResult<UsersListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersListResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { sso_id: { array: { explode: false } } } },
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/',
    ...options
  })

/**
 * Requires a shared workspace with the requested user; no workspace permission is required.
 */
export const usersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<UsersRetrieveData, ThrowOnError>
): RequestResult<UsersRetrieveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UsersRetrieveResponses, unknown, ThrowOnError>(
    {
      responseType: 'json',
      security: [
        {
          key: 'BearerAuth',
          name: 'Authorization',
          type: 'apiKey'
        }
      ],
      url: '/users/{id}/',
      ...options
    }
  )

/**
 * Requires the caller to be the requested user or a workspace administrator.
 */
export const usersPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UsersPartialUpdateData, ThrowOnError>
): RequestResult<UsersPartialUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    UsersPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires a workspace administrator.
 */
export const usersAddInOrganizationCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<UsersAddInOrganizationCreateData, ThrowOnError>
): RequestResult<
  UsersAddInOrganizationCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UsersAddInOrganizationCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/add-in-organization/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const usersArchiveCreate = <ThrowOnError extends boolean = false>(
  options: Options<UsersArchiveCreateData, ThrowOnError>
): RequestResult<
  UsersArchiveCreateResponses,
  UsersArchiveCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UsersArchiveCreateResponses,
    UsersArchiveCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/archive/{user_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const usersArchiveDependenciesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<UsersArchiveDependenciesRetrieveData, ThrowOnError>
): RequestResult<
  UsersArchiveDependenciesRetrieveResponses,
  UsersArchiveDependenciesRetrieveErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    UsersArchiveDependenciesRetrieveResponses,
    UsersArchiveDependenciesRetrieveErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/archive/{user_id}/dependencies/',
    ...options
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const usersArchiveReplaceAndArchiveCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<UsersArchiveReplaceAndArchiveCreateData, ThrowOnError>
): RequestResult<
  UsersArchiveReplaceAndArchiveCreateResponses,
  UsersArchiveReplaceAndArchiveCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UsersArchiveReplaceAndArchiveCreateResponses,
    UsersArchiveReplaceAndArchiveCreateErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/archive/{user_id}/replace-and-archive/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const usersArchiveJobsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<UsersArchiveJobsRetrieveData, ThrowOnError>
): RequestResult<
  UsersArchiveJobsRetrieveResponses,
  UsersArchiveJobsRetrieveErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    UsersArchiveJobsRetrieveResponses,
    UsersArchiveJobsRetrieveErrors,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/archive/jobs/{job_id}/',
    ...options
  })

/**
 * Edits the caller's own user record. No workspace permission is required.
 */
export const usersEditPartialUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<UsersEditPartialUpdateData, ThrowOnError>
): RequestResult<UsersEditPartialUpdateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).patch<
    UsersEditPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/edit/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })

/**
 * Edits the caller's own user record. No workspace permission is required.
 *
 * @deprecated
 */
export const usersEditUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UsersEditUpdateData, ThrowOnError>
): RequestResult<UsersEditUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<
    UsersEditUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/edit/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const usersLoginAdminCreate = <ThrowOnError extends boolean = false>(
  options?: Options<UsersLoginAdminCreateData, ThrowOnError>
): RequestResult<UsersLoginAdminCreateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    UsersLoginAdminCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/login/admin/',
    ...options
  })

export const usersLoginUserCreate = <ThrowOnError extends boolean = false>(
  options: Options<UsersLoginUserCreateData, ThrowOnError>
): RequestResult<UsersLoginUserCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    UsersLoginUserCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/login/user/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const usersNotificationServiceSyncCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<UsersNotificationServiceSyncCreateData, ThrowOnError>
): RequestResult<
  UsersNotificationServiceSyncCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UsersNotificationServiceSyncCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/notification-service-sync/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Requires a workspace administrator.
 */
export const usersSyncActiveDirectoryCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<UsersSyncActiveDirectoryCreateData, ThrowOnError>
): RequestResult<
  UsersSyncActiveDirectoryCreateResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UsersSyncActiveDirectoryCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        key: 'BearerAuth',
        name: 'Authorization',
        type: 'apiKey'
      }
    ],
    url: '/users/sync-active-directory/{organization_id}/',
    ...options
  })
